import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import axiosApiInstance from "app/services/axios";
import {
  getDataEndPoint,
  updateDataEndPoint,
  createUpdateDomainIABEndpoint,
  getReportingDataEndPoint,
  getAllCampaignsListApiUrl,
  getCampaignBidPriceDataEndPoint,
  updateCampaignBidPriceDataEndPoint,
  setCampaignBannerTargetingDataEndPoint,
  insertDataEndPoint,
} from "app/utils/constants/paths";
import uuid from "react-uuid";
import cloneDeep from "lodash.clonedeep";
import { DATASOURCE_CONFIG, DEFAULT_SHOW_ALL_CAMPAIGNS } from "app/config";
import { addslashes } from "app/utils/utils";
import moment from "moment";
import { Providers, ProvidersNameList } from "app/utils/constants/data";

const tablePrefix = DATASOURCE_CONFIG.TABLE_PREFIX;
const defaultshowallcampaigns = DEFAULT_SHOW_ALL_CAMPAIGNS;

const normalizeAudienceProviderCodes = (payload = {}) => {
  const providerCodes = new Set(
    String(payload?.providers || "")
      .split(",")
      .map((provider) => provider.trim())
      .filter(Boolean)
  );

  if (
    providerCodes.has("mobqcustom") ||
    providerCodes.has("pixel") ||
    providerCodes.has("retarget")
  ) {
    providerCodes.add("pixel");
    providerCodes.add("retarget");
    providerCodes.add("crm");
  }

  if (
    payload?.is_sys_admin == 1 ||
    payload?.user_permissions?.includes("enable_geointel")
  ) {
    providerCodes.add("mobqcustom");
    providerCodes.add("pixel");
    providerCodes.add("retarget");
    providerCodes.add("crm");
    providerCodes.add("mobiquity");
    providerCodes.add("geointel_tags");
    providerCodes.add("microssp");
  }

  return Array.from(providerCodes);
};

const initialState = {
  submitLoading: false,
  CampaignsList: [],
  TargtingTypeOptions: {},
  isTargetingTypesLoaded: false,
  locationGroupLoading: false,
  CampaignInventoryLoading: false,
  bannerLoader: false,
  bannerLocationGroupLoading: false,
  BannerInventoryLoading: false,
  globalSegmentsList: [],
  customSegmentsList: [],
  copyCampaignLoading: false,
  campaignFilterFormValues: {
    accounts: [],
    advertisers: [],
    packages: [],
    campaigns: [],
    status: defaultshowallcampaigns ? [] : [{ label: "Active", value: 0 }],
    startDate: "",
    endDate: "",
  },
  campaignFilters: {
    accounts: [],
    advertisers: [],
    packages: [],
    campaigns: [],
    status: defaultshowallcampaigns ? [""] : [0],
    startDate: "",
    endDate: "",
  },
  segmentLoader: false,
  providersList: {},
  reportLoading: false,
  emailGroupsList: [],
  zipcodeGroupsList: [],
  latlonGroupsList: [],
  addressGroupsList: [],
  ipaddressGroupsList: [],
  polygonGroupsList: [],
  searchTargtingGroupLoading: false,
  retargetCampaignsList: [],
  bannerTargetingModalLoading: false,
  campaignPackageList: [],
  creativeCopyTargets: [],
  creativeCopyLoading: false,
  bulkGoalUpdateLoading: false,
  // submitBannerTargetingLoading:false,
};
export const GetAllCampaignsListThunk = createAsyncThunk(
  "company/GetAllCampaignsListThunk",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userProfile = payload?.authUserData?.user_assoc_profiles;
    var campaignFilters = payload?.campaignFilters;
    let statusFilters = campaignFilters?.status;
    let userId = payload?.authUserData?.id;

    if (campaignFilters?.advertisers?.length <= 0 && isSysAdmin != 1) {
      if (
        userProfile.includes("advertiser") &&
        payload?.authUserData?.user_assoc_advertisers.length > 0
      ) {
        campaignFilters.advertisers =
          payload?.authUserData?.user_assoc_advertisers;
      } else {
        campaignFilters.advertisers = [0]; // For API creation campaigns
      }
    }

    let f_start_date = "";
    let f_end_date = "";
    if (
      campaignFilters?.startDate &&
      campaignFilters?.startDate != "" &&
      campaignFilters?.startDate != null
    ) {
      const sdt = new Date(campaignFilters?.startDate);
      f_start_date = sdt.toISOString().split("T")[0];
      f_start_date = f_start_date + " 00:00:00";
    }
    if (
      campaignFilters?.endDate &&
      campaignFilters?.endDate != "" &&
      campaignFilters?.endDate != null
    ) {
      const edt = new Date(campaignFilters?.endDate);
      f_end_date = edt.toISOString().split("T")[0];
      f_end_date = f_end_date + " 23:59:59";
    }

    const queryBody = {
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      search: payload?.search,
      account_id: campaignFilters?.accounts,
      advertiser_id: campaignFilters?.advertisers,
      package_id: campaignFilters?.packages,
      campaign_id: campaignFilters?.campaigns,
      user_id: userId,
      status: campaignFilters?.status,
      f_startdate: f_start_date,
      f_enddate: f_end_date,
      f_timezone: payload?.authUserData?.report_timezone_country,
      userData: {
        is_sys_admin: payload?.authUserData?.is_sys_admin,
        user_id: payload?.authUserData?.user_id,
        show_pub_names:
          payload?.authUserData?.user_permissions?.includes("show_pub_names") ==
          true
            ? 1
            : 0,
      },
    };

    try {
      const response = await axiosApiInstance.post(
        getAllCampaignsListApiUrl,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllCampaignsListThunkOld = createAsyncThunk(
  "company/GetAllCampaignsListThunkOld",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;
    var userProfile = payload?.authUserData?.user_assoc_profiles;
    var campaignFilters = payload?.campaignFilters;
    let statusFilters = campaignFilters?.status;
    let userId = payload?.authUserData?.id;

    let condition = [];
    if (
      statusFilters != null &&
      statusFilters.length > 0 &&
      statusFilters?.includes("pin")
    ) {
      let finalFilters = [];
      for (let k = 0; k < statusFilters.length; k++) {
        if (statusFilters[k] != "pin") {
          finalFilters.push(statusFilters[k]);
        }
      }
      statusFilters = finalFilters;
      condition.push(
        "id IN (SELECT campaignid FROM pinned_campaigns WHERE campaignid=campaigns.id and userid='" +
          userId +
          "')"
      );
    }
    if (
      (statusFilters.length > 0 && statusFilters?.includes("3") == true) ||
      statusFilters.length <= 0
    ) {
      condition.push(
        "(expire_time >= " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " " +
          DATASOURCE_CONFIG.CAMPAIGN_UNDEFINE_TIME +
          " OR expire_time is null OR  expire_time > " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " - " +
          DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
          ")"
      );
    } else {
      condition.push(
        "(expire_time >= " +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " " +
          DATASOURCE_CONFIG.CAMPAIGN_UNDEFINE_TIME +
          " OR expire_time is null )"
      );
    }
    //condition.push("(expire_time >= "+DATASOURCE_CONFIG.CURRENT_DATE+" OR expire_time is null)");
    if (
      payload?.search != "" &&
      payload?.search != undefined &&
      payload?.search != null
    ) {
      condition.push(
        "name " + DATASOURCE_CONFIG.QUERY_LIKE + " '%" + payload.search + "%'"
      );
    }

    if (campaignFilters?.accounts.length > 0) {
      condition.push(
        "accountid IN ('" + campaignFilters?.accounts.join("','") + "')"
      );
    }

    if (campaignFilters?.campaigns?.length > 0) {
      condition.push(
        "id IN ('" + campaignFilters?.campaigns.join("','") + "')"
      );
    }

    if (campaignFilters?.advertisers.length > 0) {
      //let advStr = "'"+campaignFilters.advertisers.join("','")+"'";
      condition.push(
        "advertiserid IN ('" + campaignFilters?.advertisers.join("','") + "')"
      );
    } else {
      if (isSysAdmin != 1) {
        if (
          userProfile.includes("advertiser") &&
          payload?.authUserData?.user_assoc_advertisers.length > 0
        ) {
          condition.push(
            "advertiserid IN ('" +
              payload?.authUserData?.user_assoc_advertisers.join("','") +
              "')"
          );
        } else {
          condition.push("advertiserid  IN ('0')");
        }
      }
    }

    //condition.push("status !='2'");

    if (statusFilters != null && statusFilters.length > 0) {
      var statusStr = "'" + statusFilters.join("','") + "'";
      condition.push("status in (" + statusStr + ")");
    } else {
      condition.push("status in ('0','1','-1','4','3')");
    }

    let where = "";
    if (condition.length > 0) {
      where = "where " + condition.join(" and ") + "";
    }

    const queryBody = {
      queries: [
        {
          query:
            "select id,name,advertiserid as advertiser_id,DATE_FORMAT(activate_time,'%Y-%m-%d %H:%i:%s') as activate_time,DATE_FORMAT(expire_time,'%Y-%m-%d %H:%i:%s') as expire_time,status,trafficking_timezone_country,creation_date,campaign_availability,cta_type,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,(select name from " +
            tablePrefix +
            "advertisers where id=" +
            tablePrefix +
            "campaigns.advertiserid) as advertiser_name,EXISTS(SELECT * FROM pinned_campaigns WHERE campaignid=campaigns.id AND userid='" +
            userId +
            "') AS isPinned from " +
            tablePrefix +
            "campaigns " +
            where +
            " order by creation_date DESC",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const CreateUpdateCampaignDetailsThunk = createAsyncThunk(
  "company/CreateUpdateCampaignDetailsThunk",
  async (payload) => {
    let ExpireDate = "'" + payload.end_date + "'";
    if (payload.end_date == null || payload.end_date == "") {
      ExpireDate = "'0000-00-00 00:00:00'";
    }
    let Query = "";
    let campaigncolumns = "";
    let inventorycolumns = "";

    if (payload.id == "" || payload.id == null || payload.id == undefined) {
      campaigncolumns =
        "id,name,advertiserid,accountid,target_country,cta_type,trafficking_timezone_country,activate_time,expire_time,rev_share,margin,adv_domains,adv_cats,content_type,is_seat_on_platform,campaign_currency,revenue,total_budget,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_click_cap,monthly_conversion_cap,monthly_impression_cap,value_add_clicks,value_add_conversions,value_add_impressions,manual_daily_limits,pacing,status,target_segments,segments_conditions,segments_conditions_ui,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,search_keywords,target_days,target_hours,has_attribution,attribution_window_days,target_attribution_poi,target_attribution_addressgroups,target_attribution_polygons,target_attribution_polygongroups,target_attribution_addressradius,package";
      inventorycolumns =
        ",target_app_language,target_app,target_cats,target_pubs,target_placements,target_supply_deal_id,target_bundles,target_skippable";
      Query =
        "insert into " +
        tablePrefix +
        "campaigns (id,name,advertiserid,accountid,target_country,cta_type,trafficking_timezone_country,activate_time,expire_time,rev_share,margin,adv_domains,adv_cats,content_type,is_seat_on_platform,campaign_currency,revenue,total_budget,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,target_app_language,target_app,target_cats,target_pubs,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,creation_date,updated,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_click_cap,monthly_conversion_cap,monthly_impression_cap,value_add_clicks,value_add_conversions,value_add_impressions,manual_daily_limits,pacing,status,target_segments,segments_conditions,segments_conditions_ui,target_id_sources,target_placements,target_supply_deal_id,target_bundles,created_by,target_skippable,future_retargeting,retarget_campaign,retarget_type,future_retargeting_exclude,retarget_additional_audience,search_keywords,target_days,target_hours,has_attribution,attribution_window_days,target_attribution_poi,target_attribution_addressgroups,target_attribution_polygons,target_attribution_polygongroups,target_attribution_addressradius,package) values('" +
        payload.campaign_create_id +
        "','" +
        addslashes(payload.name) +
        "','" +
        payload.advartiser_id +
        "','" +
        payload.accountid +
        "','" +
        payload.country +
        "','" +
        payload.cta_type +
        "','" +
        payload.timezone +
        "','" +
        payload.start_date +
        "'," +
        ExpireDate +
        ",'" +
        payload.rev_share +
        "','" +
        payload.margin +
        "','" +
        payload.adv_domain +
        "','" +
        payload.adv_cats +
        "','" +
        payload.content_type +
        "','" +
        payload.seat_type +
        "','" +
        payload.currency +
        "','" +
        payload.ecpm +
        "','" +
        payload.total_budget +
        "','" +
        payload.frequency_capping +
        "','" +
        payload.click_frequency_capping +
        "','" +
        payload.conv_frequency_capping +
        "','" +
        payload.complete_frequency_capping +
        "','" +
        payload.target_app_language +
        "','" +
        payload.target_app +
        "','" +
        payload.target_cats +
        "','" +
        payload.target_pubs +
        "','" +
        payload.target_devicetype +
        "','" +
        payload.target_orientation +
        "','" +
        payload.target_device_os +
        "','" +
        payload.target_connectiontype +
        "','" +
        payload.target_gender +
        "','" +
        payload.target_age +
        "'," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",'" +
        payload.daily_impression_cap +
        "','" +
        payload.daily_click_cap +
        "','" +
        payload.daily_conversion_cap +
        "','" +
        payload.total_impression_cap +
        "','" +
        payload.total_click_cap +
        "','" +
        payload.total_conversion_cap +
        "','" +
        payload.monthly_click_cap +
        "','" +
        payload.monthly_conversion_cap +
        "','" +
        payload.monthly_impression_cap +
        "','" +
        payload.value_add_clicks +
        "','" +
        payload.value_add_conversions +
        "','" +
        payload.value_add_impressions +
        "','" +
        payload.manual_daily_limits +
        "','" +
        payload.pacing +
        "','" +
        payload.status +
        "','" +
        payload.target_segments +
        "','" +
        payload.segments_conditions +
        "','" +
        addslashes(payload.segments_conditions_ui) +
        "','" +
        (payload.target_id_sources || "") +
        "','" +
        payload.target_placements +
        "','" +
        payload.target_supply_deal_id +
        "','" +
        payload.target_bundles +
        "','" +
        payload.created_by +
        "','" +
        payload.target_skippable +
        "','" +
        payload.campaign_future_retargeting +
        "','" +
        payload.retarget_type +
        "','" +
        payload.retargeting_campaigns +
        "','" +
        payload.retargeting_exclude +
        "','" +
        payload.retarget_additional_audience +
        "','" +
        addslashes(payload.adkeywords) +
        "','" +
        payload.target_days +
        "','" +
        payload.target_hours +
        "','" +
        payload.has_attribution +
        "','" +
        payload.attribution_window_days +
        "','" +
        addslashes(payload.target_attribution_poi) +
        "','" +
        addslashes(payload.target_attribution_addressgroups) +
        "','" +
        addslashes(payload.target_attribution_polygons) +
        "','" +
        addslashes(payload.target_attribution_polygongroups) +
        "','" +
        payload.target_attribution_addressradius +
        "','" +
        payload.package +
        "') ";
    } else {
      var inventoryTabFields = "";
      campaigncolumns =
        "id,name,advertiserid,accountid,target_country,cta_type,trafficking_timezone_country,activate_time,expire_time,rev_share,margin,adv_domains,adv_cats,content_type,is_seat_on_platform,campaign_currency,revenue,total_budget,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_click_cap,monthly_conversion_cap,monthly_impression_cap,value_add_clicks,value_add_conversions,value_add_impressions,manual_daily_limits,pacing,status,target_segments,segments_conditions,segments_conditions_ui,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,search_keywords,target_days,target_hours,has_attribution,attribution_window_days,target_attribution_poi,target_attribution_addressgroups,target_attribution_polygons,target_attribution_polygongroups,target_attribution_addressradius,package";

      var goalTabFields =
        ",daily_impression_cap='" +
        payload.daily_impression_cap +
        "',daily_click_cap='" +
        payload.daily_click_cap +
        "',daily_conversion_cap='" +
        payload.daily_conversion_cap +
        "',total_impression_cap='" +
        payload.total_impression_cap +
        "',total_click_cap='" +
        payload.total_click_cap +
        "',total_conversion_cap='" +
        payload.total_conversion_cap +
        "',monthly_click_cap='" +
        payload.monthly_click_cap +
        "',monthly_conversion_cap='" +
        payload.monthly_conversion_cap +
        "',monthly_impression_cap='" +
        payload.monthly_impression_cap +
        "',value_add_clicks='" +
        payload.value_add_clicks +
        "',value_add_conversions='" +
        payload.value_add_conversions +
        "',value_add_impressions='" +
        payload.value_add_impressions +
        "',manual_daily_limits='" +
        payload.manual_daily_limits +
        "',pacing='" +
        payload.pacing +
        "' ";

      if (payload?.status == 0) {
        goalTabFields += ",status=" + payload?.status + "";
      } else if (payload?.reactivateCampaign == true) {
        goalTabFields += ",status='1'";
      }

      if (payload?.update_inventory_tab) {
        inventoryTabFields =
          ",target_pubs='" +
          payload.target_pubs +
          "',target_placements='" +
          payload.target_placements +
          "',target_supply_deal_id='" +
          payload.target_supply_deal_id +
          "',target_bundles='" +
          payload.target_bundles +
          "',target_app_language='" +
          payload.target_app_language +
          "',target_app='" +
          payload.target_app +
          "',target_cats='" +
          payload.target_cats +
          "',target_skippable='" +
          payload.target_skippable +
          "'";
        inventorycolumns =
          ",target_app_language,target_app,target_cats,target_pubs,target_placements,target_supply_deal_id,target_bundles,target_skippable";
      }

      Query =
        "update " +
        tablePrefix +
        "campaigns set name='" +
        addslashes(payload.name) +
        "',advertiserid='" +
        payload.advartiser_id +
        "',target_country='" +
        payload.country +
        "',cta_type='" +
        payload.cta_type +
        "',trafficking_timezone_country='" +
        payload.timezone +
        "',activate_time='" +
        payload.start_date +
        "',expire_time=" +
        ExpireDate +
        ",rev_share='" +
        payload.rev_share +
        "',margin='" +
        payload.margin +
        "',adv_domains='" +
        payload.adv_domain +
        "',adv_cats='" +
        payload.adv_cats +
        "',content_type='" +
        payload.content_type +
        "',is_seat_on_platform='" +
        payload.seat_type +
        "',campaign_currency='" +
        payload.currency +
        "',revenue='" +
        payload.ecpm +
        "',total_budget='" +
        payload.total_budget +
        "',frequency_capping='" +
        payload.frequency_capping +
        "',click_frequency_capping='" +
        payload.click_frequency_capping +
        "',conv_frequency_capping='" +
        payload.conv_frequency_capping +
        "',complete_frequency_capping='" +
        payload.complete_frequency_capping +
        "',target_devicetype='" +
        payload.target_devicetype +
        "',target_orientation='" +
        payload.target_orientation +
        "',target_device_os='" +
        payload.target_device_os +
        "',target_connectiontype='" +
        payload.target_connectiontype +
        "',target_gender='" +
        payload.target_gender +
        "',target_age='" +
        payload.target_age +
        "',target_segments='" +
        payload.target_segments +
        "',future_retargeting='" +
        payload.campaign_future_retargeting +
        "',retarget_campaign='" +
        payload.retargeting_campaigns +
        "',retarget_type='" +
        payload.retarget_type +
        "',future_retargeting_exclude='" +
        payload.retargeting_exclude +
        "',retarget_additional_audience='" +
        payload.retarget_additional_audience +
        "',segments_conditions='" +
        payload.segments_conditions +
        "',segments_conditions_ui='" +
        addslashes(payload.segments_conditions_ui) +
        "',target_id_sources='" +
        (payload.target_id_sources || "") +
        "',search_keywords='" +
        addslashes(payload.adkeywords) +
        "',target_days='" +
        payload.target_days +
        "' ,target_hours='" +
        payload.target_hours +
        "' ,has_attribution='" +
        payload.has_attribution +
        "' ,attribution_window_days='" +
        payload.attribution_window_days +
        "' ,target_attribution_poi='" +
        addslashes(payload.target_attribution_poi) +
        "' ,target_attribution_addressgroups='" +
        addslashes(payload.target_attribution_addressgroups) +
        "' ,target_attribution_polygons='" +
        addslashes(payload.target_attribution_polygons) +
        "' ,target_attribution_polygongroups='" +
        addslashes(payload.target_attribution_polygongroups) +
        "' ,target_attribution_addressradius='" +
        payload.target_attribution_addressradius +
        "' ,package='" +
        payload.package +
        "'   " +
        inventoryTabFields +
        " " +
        goalTabFields +
        ",updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " where id='" +
        payload.id +
        "'";
    }
    const queryBody = {
      queries: [
        {
          query: Query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "campaigns",
            columns: "" + campaigncolumns + inventorycolumns + " ",
            id:
              payload.id != "" && payload.id != undefined
                ? payload.id
                : payload.campaign_create_id,
            user_details: payload.user_details,
            context: "campaigns",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCampaignPackagesListThunk = createAsyncThunk(
  "user/GetCampaignPackagesListThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id as value,name as label,accountid from " +
            tablePrefix +
            "campaign_packages",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCreativeCopyTargetsThunk = createAsyncThunk(
  "company/GetCreativeCopyTargetsThunk",
  async (payload) => {
    const advertiserId = addslashes(payload?.advertiser_id || "");
    const sourceCampaignId = addslashes(payload?.source_campaign_id || "");

    const queryBody = {
      queries: [
        {
          query:
            "select c.id as value,c.name as label,c.package as package_id,COALESCE(NULLIF(cp.name, ''), CASE WHEN c.package='-1' THEN 'Default Campaign' ELSE CONCAT('Campaign ', c.package) END) as package_name from " +
            tablePrefix +
            "campaigns c left join " +
            tablePrefix +
            "campaign_packages cp on c.package = cp.id where c.advertiserid='" +
            advertiserId +
            "' and c.status != 2 " +
            (sourceCampaignId != ""
              ? " and c.id != '" + sourceCampaignId + "' "
              : "") +
            " order by package_name asc, label asc",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      return response;
    } catch (err) {
      console.log("response", err);
    }
  }
);

export const CopyCreativeToCampaignsThunk = createAsyncThunk(
  "company/CopyCreativeToCampaignsThunk",
  async (payload) => {
    const sourceBannerId = addslashes(payload?.source_banner_id || "");
    const createdBy = addslashes(payload?.created_by || "");
    const targetCampaignIds = Array.isArray(payload?.target_campaign_ids)
      ? payload.target_campaign_ids
      : [];
    const queriesArr = [];

    if (sourceBannerId === "" || targetCampaignIds.length <= 0) {
      return { data: { error: true, message: "Invalid creative copy request" } };
    }

    targetCampaignIds.forEach((targetCampaignIdInfo) => {
      const targetCampaignId = addslashes(targetCampaignIdInfo || "");
      if (targetCampaignId === "") {
        return;
      }

      const newBannerId = uuid();
      const bannerQuery =
        "Insert into " +
        tablePrefix +
        "banners (id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,creation_date,updated,target_age,target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,activate_time,expire_time,imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts) (select '" +
        newBannerId +
        "',name,'" +
        targetCampaignId +
        "',status,template_type,target_size,html,cache_expiry,iurl," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",target_age,target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,'" +
        createdBy +
        "',activate_time,expire_time,imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts from " +
        tablePrefix +
        "banners where id='" +
        sourceBannerId +
        "')";

      queriesArr.push({
        query: bannerQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
        audit: 1,
        audit_details: {
          table: "banners",
          columns:
            "id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,target_age,target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,activate_time,expire_time,imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts",
          id: newBannerId,
          context: "banners",
          user_details: payload.user_details,
        },
      });

      const bannerLocationQuery =
        "Insert into " +
        tablePrefix +
        "banners_location_groups (id,name,banner_id,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,latlon_radius,addresses_radius,poi_radius,creation_date,updated_date,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,created_by) (select UUID(),name,'" +
        newBannerId +
        "',target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,latlon_radius,addresses_radius,poi_radius," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        "," +
        DATASOURCE_CONFIG.CURRENT_DATE +
        ",geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,'" +
        createdBy +
        "' from " +
        tablePrefix +
        "banners_location_groups where banner_id='" +
        sourceBannerId +
        "')";

      queriesArr.push({
        query: bannerLocationQuery,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });
    });

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      console.log("response", err);
    }
  }
);

export const BulkUpdateCampaignGoalsThunk = createAsyncThunk(
  "company/BulkUpdateCampaignGoalsThunk",
  async (payload) => {
    const updates = Array.isArray(payload?.updates) ? payload.updates : [];
    const queriesArr = [];

    updates.forEach((updateInfo) => {
      const campaignId = addslashes(updateInfo?.id || "");
      if (campaignId == "") {
        return;
      }

      const query =
        "update " +
        tablePrefix +
        "campaigns set total_budget='" +
        addslashes(updateInfo?.total_budget ?? 0) +
        "',manual_daily_limits='" +
        addslashes(updateInfo?.manual_daily_limits ?? 0) +
        "',pacing='" +
        addslashes(updateInfo?.pacing ?? 0) +
        "',daily_impression_cap='" +
        addslashes(updateInfo?.daily_impression_cap ?? -1) +
        "',daily_click_cap='" +
        addslashes(updateInfo?.daily_click_cap ?? -1) +
        "',daily_conversion_cap='" +
        addslashes(updateInfo?.daily_conversion_cap ?? -1) +
        "',total_impression_cap='" +
        addslashes(updateInfo?.total_impression_cap ?? -1) +
        "',total_click_cap='" +
        addslashes(updateInfo?.total_click_cap ?? -1) +
        "',total_conversion_cap='" +
        addslashes(updateInfo?.total_conversion_cap ?? -1) +
        "',monthly_impression_cap='" +
        addslashes(updateInfo?.monthly_impression_cap ?? -1) +
        "',monthly_click_cap='" +
        addslashes(updateInfo?.monthly_click_cap ?? -1) +
        "',monthly_conversion_cap='" +
        addslashes(updateInfo?.monthly_conversion_cap ?? -1) +
        "',updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " where id='" +
        campaignId +
        "'";

      queriesArr.push({
        query,
        datasource: DATASOURCE_CONFIG.DATASOURCE,
        audit: 1,
        audit_details: {
          table: "campaigns",
          columns:
            "total_budget,manual_daily_limits,pacing,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap",
          id: campaignId,
          context: "campaigns",
          user_details: payload.user_details,
        },
      });
    });

    if (queriesArr.length <= 0) {
      return { data: { error: false, results: [] } };
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      console.log("response", err);
    }
  }
);

export const InsertCampaignPackageThunk = createAsyncThunk(
  "user/InsertCampaignPackageThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "insert into " +
            tablePrefix +
            "campaign_packages (name,accountid) values('" +
            addslashes(payload.name) +
            "','" +
            payload.accountid +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          tableName: "campaign_packages",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        insertDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateCampaignPackageThunk = createAsyncThunk(
  "user/UpdateCampaignPackageThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "campaign_packages set name='" +
            addslashes(payload.name) +
            "' where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "campaign_packages",
            columns: "name",
            id: payload.id,
            context: "campaign_packages",
            user_details: payload.user_details,
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      console.log("response", err);
    }
  }
);

export const CreateCopyCampaignThunk = createAsyncThunk(
  "company/CreateCopyCampaignThunk",
  async (payload) => {
    let QueriesArr = [];

    /***Prepare Copy Campaign Query* */
    let campaignQuery =
      "Insert into " +
      tablePrefix +
      "campaigns (id,name,advertiserid,accountid,target_country,cta_type,trafficking_timezone_country,activate_time,expire_time,rev_share,margin,adv_domains,adv_cats,content_type,is_seat_on_platform,campaign_currency,revenue,total_budget,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,target_app_language,target_app,target_cats,target_pubs,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_click_cap,monthly_conversion_cap,monthly_impression_cap,value_add_clicks,value_add_conversions,value_add_impressions,manual_daily_limits,pacing,creation_date,updated,status,target_segments,segments_conditions,segments_conditions_ui,target_id_sources,target_placements,target_supply_deal_id,target_bundles,search_keywords,target_days,target_hours,created_by,has_attribution,attribution_window_days,target_attribution_poi,target_attribution_addressgroups,target_attribution_polygons,target_attribution_polygongroups,target_attribution_addressradius,package) ( select '" +
      payload.copy_campaign_id +
      "','" +
      payload.campaign_name +
      "',advertiserid,accountid,target_country,cta_type,trafficking_timezone_country,'" +
      payload.start_date +
      "','" +
      payload.end_date +
      "',rev_share,margin,adv_domains,adv_cats,content_type,is_seat_on_platform,campaign_currency,revenue,total_budget,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,target_app_language,target_app,target_cats,target_pubs,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_click_cap,monthly_conversion_cap,monthly_impression_cap,value_add_clicks,value_add_conversions,value_add_impressions,manual_daily_limits,pacing," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      "," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ",'-1',target_segments,segments_conditions,segments_conditions_ui,target_id_sources,target_placements,target_supply_deal_id,target_bundles,search_keywords,target_days,target_hours,'" +
      payload.created_by +
      "',has_attribution,attribution_window_days,target_attribution_poi,target_attribution_addressgroups,target_attribution_polygons,target_attribution_polygongroups,target_attribution_addressradius,package from " +
      tablePrefix +
      "campaigns where id='" +
      payload.campaign_id +
      "')";

    /*let campaignPlacementQuery =
      "Insert into " +
      tablePrefix +
      "campaigns_placements (campaign_id,target_placements,is_included,creation_date) (select '" +
      payload.copy_campaign_id +
      "',target_placements,is_included," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      " from " +
      tablePrefix +
      "campaigns_placements where campaign_id='" +
      payload.campaign_id +
      "')";
    let campaignSupplyDealQuery =
      "Insert into " +
      tablePrefix +
      "campaigns_supply_deals (campaign_id,supply_deal_id,is_included,creation_date) (select '" +
      payload.copy_campaign_id +
      "',supply_deal_id,is_included," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      " from " +
      tablePrefix +
      "campaigns_supply_deals where campaign_id='" +
      payload.campaign_id +
      "')";
*/
    let campaigncolumns =
      "id,name,advertiserid,accountid,target_country,cta_type,trafficking_timezone_country,activate_time,expire_time,rev_share,margin,adv_domains,adv_cats,content_type,is_seat_on_platform,campaign_currency,revenue,total_budget,frequency_capping,click_frequency_capping,conv_frequency_capping,complete_frequency_capping,daily_impression_cap,daily_click_cap,daily_conversion_cap,total_impression_cap,total_click_cap,total_conversion_cap,monthly_click_cap,monthly_conversion_cap,monthly_impression_cap,value_add_clicks,value_add_conversions,value_add_impressions,manual_daily_limits,pacing,status,target_segments,segments_conditions,segments_conditions_ui,target_devicetype,target_orientation,target_device_os,target_connectiontype,target_gender,target_age,search_keywords,target_days,target_hours,has_attribution,attribution_window_days,target_attribution_poi,target_attribution_addressgroups,target_attribution_polygons,target_attribution_polygongroups,target_attribution_addressradius,package";
    let inventorycolumns =
      ",target_app_language,target_app,target_cats,target_pubs,target_placements,target_supply_deal_id,target_bundles,target_skippable";
    QueriesArr.push({
      query: campaignQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      audit: 1,
      audit_details: {
        table: "campaigns",
        columns: "" + campaigncolumns + inventorycolumns + " ",
        id: payload.copy_campaign_id,
        user_details: payload.user_details,
        context: "campaigns",
      },
    });
    /*QueriesArr.push({
      query: campaignPlacementQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
    QueriesArr.push({
      query: campaignSupplyDealQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });*/

    /***Prepare Copy Campaign Location Group Query**/
    if (payload?.location_groups && payload.location_groups.length > 0) {
      for (let i = 0; i < payload.location_groups.length; i++) {
        let newLocId = uuid();
        let LocId = payload.location_groups[i].loc_id;
        let locQuery =
          "Insert into " +
          tablePrefix +
          "campaigns_location_groups (id,name,campaign_id,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,latlon_radius,addresses_radius,poi_radius,creation_date,updated_date,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,created_by) (select '" +
          newLocId +
          "',name,'" +
          payload.copy_campaign_id +
          "',target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,latlon_radius,addresses_radius,poi_radius," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          "," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,'" +
          payload.created_by +
          "' from " +
          tablePrefix +
          "campaigns_location_groups where id='" +
          LocId +
          "') ";
        QueriesArr.push({
          query: locQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "campaigns_location_groups",
            columns:
              "id,campaign_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups",
            id: newLocId,
            user_details: payload.user_details,
            context: "campaigns_location_groups",
          },
        });

        /**Prepare Location group Addresses** */
        /* let addressQuery =
          "Insert into " +
          tablePrefix +
          "campaigns_location_groups_addresses (location_group_id,campaign_id,addresses,creation_date) (select '" +
          newLocId +
          "','" +
          payload.copy_campaign_id +
          "',addresses," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " from " +
          tablePrefix +
          "campaigns_location_groups_addresses where location_group_id='" +
          LocId +
          "')";

        let latLngQuery =
          "Insert into " +
          tablePrefix +
          "campaigns_location_groups_latlon (location_group_id,campaign_id,target_latlon_groups,type,is_active,creation_date) (select '" +
          newLocId +
          "','" +
          payload.copy_campaign_id +
          "',target_latlon_groups,type,is_active," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " from " +
          tablePrefix +
          "campaigns_location_groups_latlon where location_group_id='" +
          LocId +
          "' and is_active=1)";

        let polygonQuery =
          "Insert into " +
          tablePrefix +
          "campaigns_location_groups_polygons (location_group_id,campaign_id,target_polygon_groups,type,is_active,creation_date) (select '" +
          newLocId +
          "','" +
          payload.copy_campaign_id +
          "',target_polygon_groups,type,is_active," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " from " +
          tablePrefix +
          "campaigns_location_groups_polygons where location_group_id='" +
          LocId +
          "' and is_active=1)";

        let poiQuery =
          "Insert into " +
          tablePrefix +
          "campaigns_location_groups_poi (location_group_id,campaign_id,target_poi,is_active,creation_date) (select '" +
          newLocId +
          "','" +
          payload.copy_campaign_id +
          "',target_poi,is_active," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " from " +
          tablePrefix +
          "campaigns_location_groups_poi where location_group_id='" +
          LocId +
          "' and is_active=1)";

        QueriesArr.push({
          query: addressQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        QueriesArr.push({
          query: latLngQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        QueriesArr.push({
          query: polygonQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        QueriesArr.push({
          query: poiQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        */
      }
    }

    /***Prepare Banner Queries**** */
    if (payload?.banners && payload.banners.length > 0) {
      for (let j = 0; j < payload.banners.length; j++) {
        let bannerInfo = payload.banners[j];
        let newBannerId = uuid();
        let bannerId = bannerInfo.banner_id;

        let BannerQuery =
          "Insert into " +
          tablePrefix +
          "banners (id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,creation_date,updated,target_placements,target_supply_deal_id,target_bundles,created_by,activate_time,expire_time,imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts) (select '" +
          newBannerId +
          "',name,'" +
          payload.copy_campaign_id +
          "',status,template_type,target_size,html,cache_expiry,iurl," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          "," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",target_placements,target_supply_deal_id,target_bundles,'" +
          payload.created_by +
          "','0000-00-00 00:00:00','0000-00-00 00:00:00',imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts from " +
          tablePrefix +
          "banners where id='" +
          bannerId +
          "')";

        if (
          bannerInfo?.location_groups &&
          bannerInfo.location_groups.length > 0
        ) {
          BannerQuery =
            "Insert into " +
            tablePrefix +
            "banners (id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,creation_date,updated,target_age,target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,activate_time,expire_time,imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts) (select '" +
            newBannerId +
            "',name,'" +
            payload.copy_campaign_id +
            "',status,template_type,target_size,html,cache_expiry,iurl," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            "," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ",target_age,target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,'" +
            payload.created_by +
            "','0000-00-00 00:00:00','0000-00-00 00:00:00',imp_type,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts from " +
            tablePrefix +
            "banners where id='" +
            bannerId +
            "')";
        }

        QueriesArr.push({
          query: BannerQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "banners",
            columns:
              "id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,target_age,target_gender,target_device_os,target_devicetype,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,imp_type,target_skippable,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours,custom_scripts",
            id: newBannerId,
            context: "banners",
            user_details: payload.user_details,
          },
        });

        /***Prepare Banner Location Group Queries** */
        if (
          bannerInfo?.location_groups &&
          bannerInfo.location_groups.length > 0
        ) {
          for (let k = 0; k < bannerInfo.location_groups.length; k++) {
            let newLocId = uuid();
            let LocId = bannerInfo.location_groups[k].loc_id;
            let locQuery =
              "Insert into " +
              tablePrefix +
              "banners_location_groups (id,name,banner_id,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,latlon_radius,addresses_radius,poi_radius,creation_date,updated_date,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,created_by) (select '" +
              newLocId +
              "',name,'" +
              newBannerId +
              "',target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,latlon_radius,addresses_radius,poi_radius," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              "," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ",geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,'" +
              payload.created_by +
              "' from " +
              tablePrefix +
              "banners_location_groups where id='" +
              LocId +
              "') ";
            QueriesArr.push({
              query: locQuery,
              datasource: DATASOURCE_CONFIG.DATASOURCE,
              audit: 1,
              audit_details: {
                table: "banners_location_groups",
                columns:
                  "id,banner_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups",
                id: newLocId,
                user_details: payload.user_details,
                context: "banners_location_groups",
              },
            });
          }
        }
      }
    }

    const queryBody = {
      queries: QueriesArr,
    };

    //console.log("queryBody:", queryBody);

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const CreateUpdateBannerTargetingThunk = createAsyncThunk(
  "company/CreateUpdateBannerTargetingThunk",
  async (payload) => {
    let queriesArr = [];

    let TargetingInfo = payload.targetingData;

    let TargetingSetFields =
      ",target_age='" +
      TargetingInfo.target_age +
      "',target_gender='" +
      TargetingInfo.target_gender +
      "',target_connectiontype='" +
      TargetingInfo.target_connectiontype +
      "',target_device_os='" +
      TargetingInfo.target_device_os +
      "',target_devicetype='" +
      TargetingInfo.target_devicetype +
      "',target_orientation='" +
      TargetingInfo.target_orientation +
      "',target_segments='" +
      addslashes(TargetingInfo.target_segments) +
      "',segments_conditions='" +
      addslashes(TargetingInfo.segments_conditions) +
      "',segments_conditions_ui='" +
      addslashes(TargetingInfo.segments_conditions_ui) +
      "'";
    TargetingSetFields +=
      ",target_app_language='" +
      TargetingInfo.target_app_language +
      "',target_app='" +
      TargetingInfo.target_app +
      "',target_skippable='" +
      TargetingInfo.target_skippable +
      "',target_cats='" +
      TargetingInfo.target_cats +
      "',target_pubs='" +
      TargetingInfo.target_pubs +
      "',target_placements='" +
      TargetingInfo.target_placements +
      "',target_supply_deal_id='" +
      TargetingInfo.target_supply_deal_id +
      "',target_bundles='" +
      TargetingInfo.target_bundles +
      "',target_days='" +
      TargetingInfo.target_days +
      "',target_hours='" +
      TargetingInfo.target_hours +
      "'";

    let targetingColumns =
      ",target_age,target_gender,target_device_os,target_devicetype,target_app,target_app_language,target_cats,target_pubs,target_placements,target_supply_deal_id,target_bundles,created_by,imp_type,target_skippable,target_segments,segments_conditions,segments_conditions_ui,target_days,target_hours";

    queriesArr.push({
      query:
        "update " +
        tablePrefix +
        "banners set has_campaign_targeting ='" +
        payload.has_campaign_targeting +
        "'" +
        TargetingSetFields +
        ",updated=" +
        DATASOURCE_CONFIG.CURRENT_DATE +
        " where id='" +
        payload?.banner_id +
        "'",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      audit: 1,
      audit_details: {
        table: "banners",
        columns: "has_campaign_targeting" + targetingColumns + "",
        id: payload.banner_id,
        user_details: payload?.user_details,
        context: "banners",
      },
    });
    let bannerLocQueriesArr = prepareBannerLocationGroupQuiries({
      formInfo: payload?.targetingData?.location_group,
      banner_id: payload?.banner_id,
      user_details: payload?.user_details,
      action: "edit",
    });

    queriesArr = queriesArr.concat(bannerLocQueriesArr);

    console.log("QueriesArr:", queriesArr);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const CreateUpdateCampaignLocationDetailsThunk = createAsyncThunk(
  "company/CreateUpdateCampaignLocationDetailsThunk",
  async (payload) => {
    let queriesArr = [];
    var campaignId = payload.campaign_id;
    var action = payload.action;
    var userDetails = payload.user_details;
    if (payload.is_location) {
      let InsertQuery =
        "insert into " +
        tablePrefix +
        "campaigns_location_groups (id,campaign_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,creation_date,updated_date,created_by) values";
      let InsertValuesArr = [];

      /*
      let InsertLocationLatLongQry =
        "Insert into " +
        tablePrefix +
        "campaigns_location_groups_latlon (id,location_group_id,campaign_id,target_latlon_groups,type,creation_date) values ";

      let InsertLocationAddressesQry =
        "Insert into " +
        tablePrefix +
        "campaigns_location_groups_addresses (location_group_id,campaign_id,addresses,type,creation_date) values ";
      let InsertLocationPolygongQry =
        "Insert into " +
        tablePrefix +
        "campaigns_location_groups_polygons (id,location_group_id,campaign_id,target_polygon_groups,type,creation_date) values";
      let InsertLocationPoiQry =
        "Insert into " +
        tablePrefix +
        "campaigns_location_groups_poi (location_group_id,campaign_id,target_poi,creation_date) values";
     */
      let InsertLocationLatLongValues = [];
      let InsertLocationAddressesValues = [];
      let InsertLocationPolygongValues = [];
      let InsertLocationPoiValues = [];

      var locationGroupFieldsInfo = payload.formInfo;

      //&& locationGroupFieldsInfo.length
      if (action == "edit") {
        queriesArr.push({
          query:
            "update " +
            tablePrefix +
            "campaigns_location_groups set is_active=0 where  campaign_id='" +
            campaignId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        /*** Delete all campaign location groups child tables ***/
        /*queriesArr.push({
          query:
            "delete from consent.campaigns_location_groups_latlon where  campaign_id='" +
            campaignId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        queriesArr.push({
          query:
            "delete from consent.campaigns_location_groups_polygons where campaign_id='" +
            campaignId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });*/

        /* queriesArr.push({
          query:
            "delete from " +
            tablePrefix +
            "campaigns_location_groups_addresses where  campaign_id='" +
            campaignId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        queriesArr.push({
          query:
            "delete from " +
            tablePrefix +
            "campaigns_location_groups_poi where  campaign_id='" +
            campaignId +
            "' ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        */
      }
      let locationGroupIdArr = [];
      for (var n = 0; n < locationGroupFieldsInfo.length; n++) {
        var locationInfo = locationGroupFieldsInfo[n];
        var locId = "";
        if (
          locationInfo.id == "" ||
          locationInfo.id == null ||
          locationInfo.id == undefined
        ) {
          // Create case
          //var insertId = uuid();
          locId = locationInfo.insert_id;
          locationGroupIdArr.push(locId);
          InsertValuesArr.push(
            "('" +
              locId +
              "','" +
              campaignId +
              "','" +
              addslashes(locationInfo.name) +
              "','" +
              locationInfo.target_city +
              "','" +
              locationInfo.target_state +
              "','" +
              locationInfo.target_dma +
              "','" +
              locationInfo.target_counties +
              "','" +
              locationInfo.target_zipcode +
              "','" +
              locationInfo.target_brands +
              "','" +
              locationInfo.target_congressional_districts +
              "','" +
              locationInfo.target_senate_districts +
              "','" +
              locationInfo.target_house_districts +
              "','" +
              locationInfo.latlon_radius +
              "','" +
              locationInfo.addresses_radius +
              "','" +
              locationInfo.poi_radius +
              "','" +
              addslashes(locationInfo.target_latlon) +
              "','" +
              addslashes(locationInfo.target_polygon) +
              "','" +
              addslashes(locationInfo.target_poi) +
              "','" +
              addslashes(locationInfo.target_addresses) +
              "','" +
              locationInfo.target_latlon_group +
              "','" +
              locationInfo.target_polygon_group +
              "','" +
              locationInfo.target_address_group +
              "','" +
              locationInfo.target_ipaddress_group +
              "'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              "," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ",'" +
              locationInfo.created_by +
              "')"
          );
          //geo_points,geo_polygons
        } else {
          // Update case
          locId = locationInfo.id;
          queriesArr.push({
            query:
              "update " +
              tablePrefix +
              "campaigns_location_groups set is_active=1,target_city='" +
              locationInfo.target_city +
              "',target_state='" +
              locationInfo.target_state +
              "',target_dma='" +
              locationInfo.target_dma +
              "',target_counties='" +
              locationInfo.target_counties +
              "',target_postalcode='" +
              locationInfo.target_zipcode +
              "',target_brands='" +
              locationInfo.target_brands +
              "',target_congressional_districts='" +
              locationInfo.target_congressional_districts +
              "',target_senate_districts='" +
              locationInfo.target_senate_districts +
              "',target_house_districts='" +
              locationInfo.target_house_districts +
              "',latlon_radius='" +
              locationInfo.latlon_radius +
              "',addresses_radius='" +
              locationInfo.addresses_radius +
              "',poi_radius='" +
              locationInfo.poi_radius +
              "',name='" +
              addslashes(locationInfo.name) +
              "',geo_points='" +
              addslashes(locationInfo.target_latlon) +
              "',geo_polygons='" +
              addslashes(locationInfo.target_polygon) +
              "',target_poi='" +
              addslashes(locationInfo.target_poi) +
              "',target_addresses ='" +
              addslashes(locationInfo.target_addresses) +
              "',target_latlon_groups='" +
              locationInfo.target_latlon_group +
              "',target_polygon_groups='" +
              locationInfo.target_polygon_group +
              "',target_address_groups='" +
              locationInfo.target_address_group +
              "',target_ipaddress_groups='" +
              locationInfo.target_ipaddress_group +
              "',updated_date=" +
              DATASOURCE_CONFIG.CURRENT_DATE +
              " where id='" +
              locationInfo.id +
              "' and campaign_id='" +
              campaignId +
              "' ",
            datasource: DATASOURCE_CONFIG.DATASOURCE,
            audit: 1,
            audit_details: {
              table: "campaigns_location_groups",
              columns:
                "id,campaign_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups",
              id: locationInfo.id,
              user_details: userDetails,
              context: "campaigns_location_groups",
            },
          });
        }

        /***Insert Child Tables Data***/
        /* if (locationInfo?.target_poi && locationInfo.target_poi.length > 0) {
          for (var p = 0; p < locationInfo.target_poi.length; p++) {
            var poi = locationInfo.target_poi[p];
            InsertLocationPoiValues.push(
              "('" +
              locId +
              "','" +
              campaignId +
              "','" +
              JSON.stringify(poi) +
              "'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ")"
            );
          }
        }
        // For Polygons
        if (
          locationInfo?.target_polygon &&
          locationInfo.target_polygon.length > 0
        ) {
          for (var a = 0; a < locationInfo.target_polygon.length; a++) {
            var polygonInfo = locationInfo.target_polygon[a];
            if (polygonInfo.action == "add" && polygonInfo.active == 1) {
              // Insert Polygon
              delete polygonInfo.coords.is_new;
              InsertLocationPolygongValues.push(
                "('" +
                polygonInfo.id +
                "','" +
                locId +
                "','" +
                campaignId +
                "','" +
                JSON.stringify(polygonInfo.coords) +
                "','" +
                polygonInfo.type +
                "'," +
                DATASOURCE_CONFIG.CURRENT_DATE +
                ")"
              );
            } else if (polygonInfo.action == "edit") {
              // Update polygons
              queriesArr.push({
                query:
                  " update " +
                  tablePrefix +
                  "campaigns_location_groups_polygons set is_active='" +
                  polygonInfo.active +
                  "',target_polygon_groups='" +
                  JSON.stringify(polygonInfo.coords) +
                  "',type='" +
                  polygonInfo.type +
                  "' where id='" +
                  polygonInfo.id +
                  "' and location_group_id='" +
                  locId +
                  "' ",
                datasource: DATASOURCE_CONFIG.DATASOURCE,
              });
            } else if (polygonInfo.action == "delete") {
              // Update polygons
              queriesArr.push({
                query:
                  " update " +
                  tablePrefix +
                  "campaigns_location_groups_polygons set is_active='0' where id='" +
                  polygonInfo.id +
                  "' and location_group_id='" +
                  locId +
                  "' ",
                datasource: DATASOURCE_CONFIG.DATASOURCE,
              });
            }
          }
        }*/
        // if (
        //   locationInfo?.target_polygon_files &&
        //   locationInfo.target_polygon_files.length > 0
        // ) {
        //   for (var b = 0; b < locationInfo.target_polygon_files.length; b++) {
        //     var polygonInfo = locationInfo.target_polygon_files[b];
        //     InsertLocationPolygongValues.push(
        //       "('" +
        //         locId +
        //         "','" +
        //         campaignId +
        //         "','" +
        //         JSON.stringify(polygonInfo) +
        //         "','file')"
        //     );
        //   }
        // }
        // For LatLong
        /*if (
          locationInfo?.target_latlon &&
          locationInfo.target_latlon.length > 0
        ) {
          for (var d = 0; d < locationInfo.target_latlon.length; d++) {
            var latLonInfo = locationInfo.target_latlon[d];
            let geopoints;
            if (latLonInfo.type == "file") {
              geopoints = latLonInfo.geopoints;
            } else {
              geopoints = { coords: latLonInfo.geopoints };
            }
            if (latLonInfo.action == "add" && latLonInfo.active == 1) {
              delete latLonInfo.geopoints.is_new;
              InsertLocationLatLongValues.push(
                "('" +
                latLonInfo.id +
                "','" +
                locId +
                "','" +
                campaignId +
                "','" +
                JSON.stringify(geopoints) +
                "','" +
                latLonInfo.type +
                "'," +
                DATASOURCE_CONFIG.CURRENT_DATE +
                ")"
              );
            } else if (latLonInfo.action == "edit") {
              // Update Geopoints
              queriesArr.push({
                query:
                  " update " +
                  tablePrefix +
                  "campaigns_location_groups_latlon set is_active='" +
                  latLonInfo.active +
                  "',target_latlon_groups='" +
                  JSON.stringify(geopoints) +
                  "',type='" +
                  latLonInfo.type +
                  "' where id='" +
                  latLonInfo.id +
                  "' and location_group_id='" +
                  locId +
                  "' ",
                datasource: DATASOURCE_CONFIG.DATASOURCE,
              });
            } else if (latLonInfo.action == "delete") {
              // Update polygons
              queriesArr.push({
                query:
                  " update " +
                  tablePrefix +
                  "campaigns_location_groups_latlon set is_active='0' where id='" +
                  latLonInfo.id +
                  "' and location_group_id='" +
                  locId +
                  "' ",
                datasource: DATASOURCE_CONFIG.DATASOURCE,
              });
            }
          }
        }*/
        // For Addresses
        /*if (
          locationInfo?.target_addresses &&
          locationInfo.target_addresses.length > 0
        ) {
          for (var s = 0; s < locationInfo.target_addresses.length; s++) {
            var address = locationInfo.target_addresses[s];
            InsertLocationAddressesValues.push(
              "('" +
              locId +
              "','" +
              campaignId +
              "','" +
              address +
              "','manual'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ")"
            );
          }
        }*/
        /*if (
          locationInfo?.target_addresses_files &&
          locationInfo.target_addresses_files.length > 0
        ) {
          for (var t = 0; t < locationInfo.target_addresses_files.length; t++) {
            var address = locationInfo.target_addresses_files[t];
            InsertLocationAddressesValues.push(
              "('" +
              locId +
              "','" +
              campaignId +
              "','" +
              JSON.stringify(address) +
              "','file'," +
              DATASOURCE_CONFIG.CURRENT_DATE +
              ")"
            );
          }
        }*/
      }

      if (InsertValuesArr.length > 0) {
        InsertQuery += InsertValuesArr.join(",");
        queriesArr.push({
          query: InsertQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "campaigns_location_groups",
            columns:
              "id,campaign_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups",
            id:
              locationGroupIdArr.length > 0 ? locationGroupIdArr.join(",") : "",
            user_details: userDetails,
            context: "campaigns_location_groups",
          },
        });
      }
      /*if (InsertLocationLatLongValues.length > 0) {
        InsertLocationLatLongQry += InsertLocationLatLongValues.join(",");
        queriesArr.push({
          query: InsertLocationLatLongQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (InsertLocationAddressesValues.length > 0) {
        InsertLocationAddressesQry += InsertLocationAddressesValues.join(",");
        queriesArr.push({
          query: InsertLocationAddressesQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (InsertLocationPolygongValues.length > 0) {
        InsertLocationPolygongQry += InsertLocationPolygongValues.join(",");
        queriesArr.push({
          query: InsertLocationPolygongQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      if (InsertLocationPoiValues.length > 0) {
        InsertLocationPoiQry += InsertLocationPoiValues.join(",");
        queriesArr.push({
          query: InsertLocationPoiQry,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      */
    }

    /*if (payload.is_inventory) {
      //
      var queryRes = prepareCampaignInventoryQueries(
        payload.inventoryFormData,
        campaignId,
        payload.action
      );

      if (queryRes.length > 0) {
        queriesArr = queriesArr.concat(queryRes);
      }
    }*/

    if (payload.is_banner) {
      var bannerQueryRes = prepareBannerQueries(
        payload.bannerData,
        campaignId,
        userDetails
      );
      if (bannerQueryRes.length > 0) {
        queriesArr = queriesArr.concat(bannerQueryRes);
      }
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
/*const prepareCampaignInventoryQueries = (InventoryData, campaignId, type) => {
  let queriesArr = [];
  if (type == "edit") {
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "campaigns_placements where  campaign_id='" +
        campaignId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "campaigns_supply_deals where  campaign_id='" +
        campaignId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }

  let InsertQuery =
    "insert into " +
    tablePrefix +
    "campaigns_placements (campaign_id,target_placements,is_included,creation_date) values ";
  let InsertPlacementsValues = [];

  let supplyDealQuery =
    "insert into " +
    tablePrefix +
    "campaigns_supply_deals (campaign_id,supply_deal_id,is_included,creation_date) values ";
  let InsertSupplyDealValues = [];
  let isIncluded = InventoryData.placementsInfo?.is_included ? 1 : 0;
  let supplyDealIsIncluded = InventoryData.supplyDealIdsInfo?.is_included
    ? 1
    : 0;
  for (var i = 0; i < InventoryData.placementsInfo.data.length; i++) {
    InsertPlacementsValues.push(
      "('" +
      campaignId +
      "','" +
      InventoryData.placementsInfo.data[i] +
      "','" +
      isIncluded +
      "'," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ")"
    );
  }
  for (var j = 0; j < InventoryData.supplyDealIdsInfo.data.length; j++) {
    InsertSupplyDealValues.push(
      "('" +
      campaignId +
      "','" +
      InventoryData.supplyDealIdsInfo.data[j] +
      "','" +
      supplyDealIsIncluded +
      "'," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ")"
    );
  }
  if (InsertPlacementsValues.length > 0) {
    InsertQuery += InsertPlacementsValues.join(",");
    queriesArr.push({
      query: InsertQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  if (InsertSupplyDealValues.length > 0) {
    supplyDealQuery += InsertSupplyDealValues.join(",");
    queriesArr.push({
      query: supplyDealQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  return queriesArr;
};*/
/*const prepareBannerInventoryQueries = (InventoryData, bannerId, type) => {
  let queriesArr = [];
  if (type == "edit") {
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "banners_placements where  banner_id='" +
        bannerId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "banners_supply_deals where  banner_id='" +
        bannerId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  let isIncluded = InventoryData.placementsInfo?.is_included ? 1 : 0;
  let InsertQuery =
    "insert into " +
    tablePrefix +
    "banners_placements (banner_id,target_placements,is_included,creation_date) values ";
  let InsertPlacementsValues = [];
  for (var i = 0; i < InventoryData.placementsInfo.data.length; i++) {
    InsertPlacementsValues.push(
      "('" +
      bannerId +
      "','" +
      InventoryData.placementsInfo.data[i] +
      "','" +
      isIncluded +
      "'," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ")"
    );
  }
  if (InsertPlacementsValues.length > 0) {
    InsertQuery += InsertPlacementsValues.join(",");
    queriesArr.push({
      query: InsertQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }

  let supplyDealQuery =
    "insert into " +
    tablePrefix +
    "banners_supply_deals (banner_id,supply_deal_id,is_included,creation_date) values ";
  let InsertSupplyDealValues = [];

  let supplyDealIsIncluded = InventoryData.supplyDealIdsInfo?.is_included
    ? 1
    : 0;

  for (var j = 0; j < InventoryData.supplyDealIdsInfo.data.length; j++) {
    InsertSupplyDealValues.push(
      "('" +
      bannerId +
      "','" +
      InventoryData.supplyDealIdsInfo.data[j] +
      "','" +
      supplyDealIsIncluded +
      "'," +
      DATASOURCE_CONFIG.CURRENT_DATE +
      ")"
    );
  }

  if (InsertSupplyDealValues.length > 0) {
    supplyDealQuery += InsertSupplyDealValues.join(",");
    queriesArr.push({
      query: supplyDealQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  return queriesArr;
};*/
/*const prepareBannerPlacemnetQueries = (InventoryData, bannerId, type) => {
  let queriesArr = [];
  if (type == "edit") {
    queriesArr.push({
      query:
        "delete consent.banners_placements where  banner_id='" +
        bannerId +
        "' ",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  let InsertQuery =
    "insert into consent.banners_placements (banner_id,target_placements,is_included) values ";
  let InsertPlacementsValues = [];

  let isIncluded = InventoryData?.is_included ? 1 : 0;
  for (var i = 0; i < InventoryData.data.length; i++) {
    InsertPlacementsValues.push(
      "('" +
      bannerId +
      "','" +
      InventoryData.data[i] +
      "','" +
      isIncluded +
      "')"
    );
  }
  if (InsertPlacementsValues.length > 0) {
    InsertQuery += InsertPlacementsValues.join(",");
    queriesArr.push({
      query: InsertQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }
  return queriesArr;
};*/
function prepareBannerLocationGroupQuiries(payload) {
  let queriesArr = [];
  var bannerId = payload.banner_id;
  var action = payload.action;
  var userDetails = payload.user_details;
  console.log("Banner-Location Group-User details:", userDetails);
  let InsertQuery =
    "insert into " +
    tablePrefix +
    "banners_location_groups (id,banner_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups,creation_date,updated_date,created_by) values";
  let InsertValuesArr = [];

  var locationGroupFieldsInfo = payload.formInfo;
  let bannerLocationGroupIdArr = [];

  let allLocationGroupIdsArr = [];
  for (var n = 0; n < locationGroupFieldsInfo.length; n++) {
    var locationInfo = locationGroupFieldsInfo[n];
    console.log("Banner-Location-Info:", locationInfo);
    var locId = "";
    if (
      locationInfo.id == "" ||
      locationInfo.id == null ||
      locationInfo.id == undefined
    ) {
      // Create case
      //var insertId = uuid();
      locId = locationInfo.insert_id;
      allLocationGroupIdsArr.push(locId);
      bannerLocationGroupIdArr.push(locId);
      InsertValuesArr.push(
        "('" +
          locId +
          "','" +
          bannerId +
          "','" +
          addslashes(locationInfo.name) +
          "','" +
          locationInfo.target_city +
          "','" +
          locationInfo.target_state +
          "','" +
          locationInfo.target_dma +
          "','" +
          locationInfo.target_counties +
          "','" +
          locationInfo.target_zipcode +
          "','" +
          locationInfo.target_brands +
          "','" +
          locationInfo.target_congressional_districts +
          "','" +
          locationInfo.target_senate_districts +
          "','" +
          locationInfo.target_house_districts +
          "','" +
          locationInfo.latlon_radius +
          "','" +
          locationInfo.addresses_radius +
          "','" +
          locationInfo.poi_radius +
          "','" +
          addslashes(locationInfo.target_latlon) +
          "','" +
          addslashes(locationInfo.target_polygon) +
          "','" +
          addslashes(locationInfo.target_poi) +
          "','" +
          addslashes(locationInfo.target_addresses) +
          "','" +
          locationInfo.target_latlon_group +
          "','" +
          locationInfo.target_polygon_group +
          "','" +
          locationInfo.target_address_group +
          "','" +
          locationInfo.target_ipaddress_group +
          "'," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          "," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",'" +
          userDetails?.user_id +
          "')"
      );
    } else {
      // Update case
      locId = locationInfo.id;
      allLocationGroupIdsArr.push(locId);
      queriesArr.push({
        query:
          "update " +
          tablePrefix +
          "banners_location_groups set is_active=1,target_city='" +
          locationInfo.target_city +
          "',target_state='" +
          locationInfo.target_state +
          "',target_dma='" +
          locationInfo.target_dma +
          "',target_counties='" +
          locationInfo.target_counties +
          "',target_postalcode='" +
          locationInfo.target_zipcode +
          "',target_brands='" +
          locationInfo.target_brands +
          "',target_congressional_districts='" +
          locationInfo.target_congressional_districts +
          "',target_senate_districts='" +
          locationInfo.target_senate_districts +
          "',target_house_districts='" +
          locationInfo.target_house_districts +
          "',latlon_radius='" +
          locationInfo.latlon_radius +
          "',addresses_radius='" +
          locationInfo.addresses_radius +
          "',poi_radius='" +
          locationInfo.poi_radius +
          "',name='" +
          addslashes(locationInfo.name) +
          "',geo_points='" +
          addslashes(locationInfo.target_latlon) +
          "',geo_polygons='" +
          addslashes(locationInfo.target_polygon) +
          "',target_poi='" +
          addslashes(locationInfo.target_poi) +
          "',target_addresses ='" +
          addslashes(locationInfo.target_addresses) +
          "',target_latlon_groups='" +
          locationInfo.target_latlon_group +
          "',target_polygon_groups='" +
          locationInfo.target_polygon_group +
          "',target_address_groups='" +
          locationInfo.target_address_group +
          "',target_ipaddress_groups='" +
          locationInfo.target_ipaddress_group +
          "',updated_date=" +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " where id='" +
          locationInfo.id +
          "' and banner_id='" +
          bannerId +
          "' ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
        audit: 1,
        audit_details: {
          table: "banners_location_groups",
          columns:
            "id,banner_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups",
          id: locationInfo.id,
          user_details: userDetails,
          context: "banners_location_groups",
        },
      });
    }
  }
  if (action == "edit" && locationGroupFieldsInfo.length) {
    queriesArr.push({
      query:
        "delete from " +
        tablePrefix +
        "banners_location_groups where banner_id='" +
        bannerId +
        "' and id NOT IN  ('" +
        allLocationGroupIdsArr.join("','") +
        "')",
      datasource: DATASOURCE_CONFIG.DATASOURCE,
    });
  }

  if (InsertValuesArr.length > 0) {
    InsertQuery += InsertValuesArr.join(",");
    queriesArr.push({
      query: InsertQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      audit: 1,
      audit_details: {
        table: "banners_location_groups",
        columns:
          "id,banner_id,name,target_city,target_state,target_dma,target_counties,target_postalcode,target_brands,target_congressional_districts,target_senate_districts,target_house_districts,latlon_radius,addresses_radius,poi_radius,geo_points,geo_polygons,target_poi,target_addresses,target_latlon_groups,target_polygon_groups,target_address_groups,target_ipaddress_groups",
        id:
          bannerLocationGroupIdArr.length > 0
            ? bannerLocationGroupIdArr.join(",")
            : "",
        user_details: userDetails,
        context: "banners_location_groups",
      },
    });
  }

  return queriesArr;
}
export const GetCampaignDetailsThunk = createAsyncThunk(
  "company/GetCampaignDetailsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "campaigns where id='" +
            payload.id +
            "' and status !='2'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCampaignLocationGroupThunk = createAsyncThunk(
  "company/GetCampaignLocationGroupThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          /****get campaign location groups data** */
          query:
            "select * from " +
            tablePrefix +
            "campaigns_location_groups where campaign_id='" +
            payload.id +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCampaignInventoryDataThunk = createAsyncThunk(
  "company/GetCampaignInventoryDataThunk",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var targetInfo = payload[i];
      if (targetInfo.field == "target_pubs") {
        let pubquery =
          "select id,pub_code, name from " +
          tablePrefix +
          "publishers where pub_code in ('" +
          targetInfo["values"].join("','").replaceAll("account_", "") +
          "') and active='1'";

        let accountsQuery =
          "select a.id,CONCAT('account_',a.id) AS pub_code,CONCAT(a.company,' - ',a.name) AS name from " +
          tablePrefix +
          "accounts as a" +
          " where a.id IN('" +
          targetInfo["values"].join("','").replaceAll("account_", "") +
          "')";

        let finalPubQuery =
          "SELECT id,pub_code,name FROM ((" +
          pubquery +
          ") union (" +
          accountsQuery +
          ")) A";

        queriesArr.push({
          query: finalPubQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.field == "target_placements") {
        queriesArr.push({
          query:
            "select id,name,pub_code from " +
            tablePrefix +
            "publisher_placements where id in ('" +
            targetInfo.values.join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.field == "target_supply_deal_id") {
        queriesArr.push({
          query:
            "select dealid as id,name from " +
            tablePrefix +
            "rtb_deals_supply where  dealid in ('" +
            targetInfo.values.join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.field == "target_bundles") {
        queriesArr.push({
          query:
            "select id,name,is_group from  ((select BundleId as id,CONCAT(BundleId,' [',OwnName,']') as name,0 as is_group  from " +
            tablePrefix +
            "applications where status = 100 and BundleId !='' and BundleId in ('" +
            targetInfo.values.join("','") +
            "')) union (select tg_groups.id as id, CONCAT(tg_groups.name,' [',tg_groups.id,'] ') as name,1 as is_group from " +
            tablePrefix +
            " targeting_groups as tg_groups where tg_groups.id IN('" +
            targetInfo.values.join("','") +
            "'))) A",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }

    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCustomAndGlobalSegmentsList = createAsyncThunk(
  "company/GetCustomAndGlobalSegmentsList",
  async (payload) => {
    var queriesArr = [
      // {
      //   /****Get Global segments data** */
      //   query:
      //     "select id,segment,provider,displayname,segment_name from consent.audience_segments_providers asp where  is_active=1 and portal!='advertiser' and portal!='publisher' ",
      //   datasource: DATASOURCE_CONFIG.DATASOURCE,
      // },
      {
        /****Get Custom segments data** */
        query:
          "select id,segment,provider,displayname,segment_name,price from " +
          tablePrefix +
          "audience_segments_providers asp where  is_active=1 and (portal='advertiser' OR portal='publisher') and whitelist_accountid='" +
          payload.accountId +
          "'",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetSegmentsListForTargeting = createAsyncThunk(
  "company/GetSegmentsListForTargeting",
  async (payload) => {
    var isSysAdmin = payload?.authUserData?.is_sys_admin;

    var userProfile = payload?.authUserData?.user_assoc_profiles;
    let userAssocAdvertisers = payload?.authUserData?.user_assoc_advertisers;
    let userAssocAccounts = payload?.authUserData?.user_assoc_accounts;

    let parentId = "-1";
    if (payload?.parentId) {
      parentId = payload.parentId;
    }

    // and audience_segments_providers.portal in ('advertiser','publisher')
    let groupBy = "group by audience_segments_providers.segment";
    if (DATASOURCE_CONFIG.DATASOURCE == "redshift") {
      groupBy =
        "group by audience_segments_providers.segment,audience_segments_providers.segment_name,audience_segments_providers.displayname,audience_segments_providers.parent_id,audience_segments_providers.price,audience_segments_providers.has_children,audience_segments_providers.provider,audience_segments_providers.breadcrumb,audience_segments_providers.is_active,audience_segments_providers.whitelist_accountid";
    }

    let selColumns =
      "audience_segments_providers.segment,audience_segments_providers.segment_name,audience_segments_providers.displayname AS provider_name,audience_segments_providers.parent_id,audience_segments_providers.price,audience_segments_providers.has_children,audience_segments_providers.provider,audience_segments_providers.breadcrumb,audience_segments_providers.is_active,audience_segments_providers.whitelist_accountid,SUM(audience_segments_providers_counts.uniques) AS uniques ";

    let where = " and audience_segments_providers.is_active=1";
    if (parentId == "search_by") {
      if (payload.provider == "mobiquity") {
        where += ` AND (audience_segments_providers.parent_id='-1' OR audience_segments_providers.parent_id='MOBQ_3012' OR audience_segments_providers.breadcrumb LIKE '%"MOBQ_3012"%' OR  audience_segments_providers.parent_id IN (SELECT asp.segment FROM audience_segments_providers AS asp WHERE asp.provider = 'mobiquity' AND parent_id='-1' AND has_children=1))`; // OR audience_segments_providers.parent_id='MOBQ_3012'
        //selColumns += ",(SELECT GROUP_CONCAT(asp1.segment) FROM audience_segments_providers AS asp1 WHERE asp1.provider = 'mobiquity' AND asp1.parent_id='-1' AND asp1.has_children=1) AS mobiquity_parent_id";
      }
      /*where =
        payload.provider == "mobiquity"
          ? " AND (audience_segments_providers.parent_id='-1' OR audience_segments_providers.has_children=0 OR audience_segments_providers.parent_id='MOBQ_3012')"
          : "AND (audience_segments_providers.parent_id='-1' OR audience_segments_providers.has_children=0)";
          */
      where +=
        "   and audience_segments_providers.segment_name like '%" +
        payload?.searchText +
        "%' ";
      //selColumns +=",(CASE WHEN audience_segments_providers.parent_id !=-1 THEN (SELECT child.segment_name FROM audience_segments_providers AS child WHERE child.segment=audience_segments_providers.parent_id limit 1) ELSE  ' ' END) AS parent_name";
    } else {
      where += " AND audience_segments_providers.parent_id='" + parentId + "' ";
    }
    let orderBy = " order by audience_segments_providers.segment_name ";

    if (payload.provider == "microssp") {
      where +=
        " and audience_segments_providers.portal IN ('" +
        userProfile.join("','") +
        "')";
      where +=
        " and audience_segments_providers.segment_sub_type='geointel_custom' and audience_segments_providers.is_customsegment='1'";
    }

    if (
      payload.provider == "microssp" ||
      payload.provider == "prevads" ||
      payload.provider == "mobqcustom"
    ) {
      // For Custom Segments
      where +=
        " and (audience_segments_providers.expiry_date >= now() OR audience_segments_providers.expiry_date = '0000-00-00 00:00:00')";
    }
    if (isSysAdmin == 1) {
      if (payload.provider == "microssp") {
        orderBy = " order by audience_segments_providers.whitelist_accountid ";
      }
    } else {
      //user_assoc_advertisers
      // and audience_segments_providers.advertiserid IN(".$advertiserIdStr.") and customsegment_accountid IN(".$accountIdStr.")
      let advertiserAccounts = userAssocAccounts?.advertiser
        ? userAssocAccounts.advertiser
        : [];
      let publisherAccounts = userAssocAccounts?.publisher
        ? userAssocAccounts.publisher
        : [];
      let allAccounts = advertiserAccounts.concat(publisherAccounts);

      let uniqueAccounts = allAccounts.filter(
        (value, index, array) => array.indexOf(value) === index
      );

      if (payload.provider == "mobqcustom") {
        where +=
          " AND audience_segments_providers.advertiserid IN ('0','','" +
          userAssocAdvertisers.join("','") +
          "') and audience_segments_providers.customsegment_accountid IN ('" +
          uniqueAccounts.join("','") +
          "')";
      } else if (payload.provider == "microssp") {
        where +=
          " AND audience_segments_providers.advertiserid IN ('0','','" +
          userAssocAdvertisers.join("','") +
          "') and audience_segments_providers.whitelist_accountid IN ('','" +
          uniqueAccounts.join("','") +
          "')";
      } else if (
        payload.provider == "geointel_tags" ||
        payload.provider == "pixel" ||
        payload.provider == "retarget"
      ) {
        where +=
          " AND audience_segments_providers.advertiserid IN ('0','','" +
          userAssocAdvertisers.join("','") +
          "') and audience_segments_providers.whitelist_accountid IN ('0','','" +
          uniqueAccounts.join("','") +
          "')";
      } else {
        where +=
          " AND audience_segments_providers.advertiserid IN ('0','" +
          userAssocAdvertisers.join("','") +
          "') and audience_segments_providers.whitelist_accountid IN ('0','" +
          uniqueAccounts.join("','") +
          "')";
      }
    }

    var queriesArr = [
      {
        /****Get Custom segments data** */
        // query:
        //   "select asp.id,asp.segment,asp.provider,asp.displayname as provider_name,asp.segment_name,asp.price,asp.parent_id,asp.has_children,asp.provider,asp.breadcrumb,(select SUM(aspc.uniques) AS uniques from consent.audience_segments_providers_counts AS aspc where aspc.segment=asp.segment) as uniques from consent.audience_segments_providers asp where  asp.is_active=1 and asp.portal in ('advertiser','publisher') and asp.provider='" +
        //   payload.provider +
        //   "' and asp.parent_id='-1' limit 100",
        query:
          "select " +
          selColumns +
          " FROM  " +
          tablePrefix +
          "audience_segments_providers LEFT JOIN  " +
          tablePrefix +
          "audience_segments_providers_counts ON audience_segments_providers.segment = audience_segments_providers_counts.segment WHERE audience_segments_providers.provider = '" +
          payload.provider +
          "' " +
          where +
          " " +
          groupBy +
          " " +
          orderBy +
          " ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];
    console.log("Segments Query:", queriesArr);
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetIABlistFromDomains = createAsyncThunk(
  "company/GetIABlistFromDomains",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select iad.domain,iad.iab_category from " +
            tablePrefix +
            "domain_iab_category iad where domain='" +
            payload.domain +
            "' order by domain;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetTargetingTypeOptionsThunk = createAsyncThunk(
  "company/GetTargetingTypeOptionsThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,tp.key,targeting_type,icon,mui_icon from " +
            tablePrefix +
            "targeting_type_options as tp where status=1 order by  targeting_type,disp_order",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCampaignTargetingsByIds = createAsyncThunk(
  "company/GetCampaignTargetingsByIds",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var targetInfo = payload[i];
      if (targetInfo.key == "target_city") {
        let cityQuery = "";
        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          /*cityQuery =
            "select CONCAT(CONCAT(country_code, '_', state_code), '_', NAME) as concat,id, latitude as lat, longitude as lng, concat(concat((name), ' ', state_code), ' (CITY)') as name,'city' as type from " +
            tablePrefix +
            "cities where id in ('" +
            targetInfo["values"].join("','") +
            "')";
            */
          /* cityQuery =
            "select CONCAT(CONCAT(country_code, '_', state_code), '_', NAME) as concat,id, latitude as lat, longitude as lng, concat(concat((name), ' ', state_code), ' (CITY)') as name,'city' as type from " +
            tablePrefix +
            "cities where id in ('" +
            targetInfo["values"].join("','") +
            "')";*/
          cityQuery =
            "SELECT CONCAT(CONCAT(c.iso3, '_', s.`state_code`),'_',s.name) AS id,s.latitude AS lat, s.longitude AS lng,concat(concat((s.name), ' ', s.state_code), ' (CITY)') as name,'city' AS type from " +
            tablePrefix +
            "cities s,countries c  WHERE CONCAT(CONCAT(c.iso3, '_', s.`state_code`),'_',s.name) IN ('" +
            targetInfo["values"].join("','") +
            "') ";
        } else {
          // For Redshift
          cityQuery =
            "select concat(concat(concat(concat(country_code, '_'), state_code), '_'), name),id, latitude as lat, longitude as lng, concat(concat(concat((name), ' '), state_code), ' (CITY)') as name,'city' as type from " +
            tablePrefix +
            "cities where id in ('" +
            targetInfo["values"].join("','") +
            "')";
        }
        queriesArr.push({
          query: cityQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_state") {
        let stateQuery = "";
        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          let iso3Arr = [];
          let fipArr = [];
          targetInfo["values"].map((item) => {
            let stateIdStr = item.split("_");
            iso3Arr.push(stateIdStr[0]);
            fipArr.push(stateIdStr[1]);
          });
          iso3Arr = iso3Arr.filter(function (elem, index, self) {
            return index === self.indexOf(elem);
          });
          stateQuery =
            "SELECT CONCAT(c.iso3, '_', s.`iso2`) AS id, CONCAT(s.name,' [',s.iso2,']',' (STATE)') AS name, s.latitude AS lat, s.longitude AS lng,'state' AS type FROM states s,countries c WHERE s.`country_code`=c.iso2 AND c.iso3 in ('" +
            iso3Arr.join("','") +
            "') and s.iso2 in ('" +
            fipArr.join("','") +
            "') ";

          //   "select concat(country_code, '_', iso2) as state_code,id,  concat(name,' (STATE)') as name, latitude as lat, longitude as lng,'state' as type from " +
          //   tablePrefix +
          //  "states where id in ('" +
          //   targetInfo["values"].join("','") +
          //  "')";
        } else {
          // This query for redshift
          stateQuery =
            "SELECT CONCAT(c.iso3, '_', s.`iso2`) AS id, CONCAT(s.name,' (STATE)') AS name, s.latitude AS lat, s.longitude AS lng,'state' AS type " +
            tablePrefix +
            "states s, " +
            tablePrefix +
            "countries c where id in ('" +
            targetInfo["values"].join("','") +
            "') ";
        }
        queriesArr.push({
          query: stateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_dma") {
        queriesArr.push({
          query:
            "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
            tablePrefix +
            "geodma where dma_code in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_counties") {
        let CountiesQuery = "";
        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          CountiesQuery =
            "select id as county_code, CONCAT(CONCAT(county_name, ' [', state_name), ']',CONCAT('[',id, ']')) as name from " +
            tablePrefix +
            "counties where id in ('" +
            targetInfo["values"].join("','") +
            "')";
        } else {
          // For Redshift
          CountiesQuery =
            "select id as county_code, concat(concat(county_name, ' '), state_name) as name from " +
            tablePrefix +
            "counties where id in ('" +
            targetInfo["values"].join("','") +
            "')";
        }
        queriesArr.push({
          query: CountiesQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (
        targetInfo.key == "brands" ||
        targetInfo.key == "target_brands"
      ) {
        queriesArr.push({
          query:
            "select id as brand_id,id, name,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: "redshift",
        });
      } else if (targetInfo.key == "target_poi") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name as brand,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_congressional_districts") {
        let congQuery =
          "SELECT dm.id AS id,concat(concat(state_code, '-'), cd116_fip) AS name,0 as lat,0 as lng FROM " +
          tablePrefix +
          "congressional_districts dm where  id in ('" +
          targetInfo["values"].join("','") +
          "') GROUP BY dm.id,dm.state_code, cd116_fip  ORDER BY name";
        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          congQuery =
            "SELECT dm.id AS id,CONCAT(dm.state_name, ' Congressional District ', dm.id) AS name,dm.latitude as lat,dm.longitude as lng FROM " +
            tablePrefix +
            "congressional_districts dm where  id in ('" +
            targetInfo["values"].join("','") +
            "') ORDER BY name";
        }

        queriesArr.push({
          query: congQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_senate_districts") {
        let senateQuery =
          "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,0 as lat,0 as lng FROM " +
          tablePrefix +
          "state_legislative_districts dm WHERE dm.geo_id in ('" +
          targetInfo["values"].join("','") +
          "') and sld='U' GROUP BY dm.geo_id,dm.state_code,district ORDER BY name;";

        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          senateQuery =
            "SELECT dm.geo_id AS id,CONCAT(dm.state_code, '-',dm.name) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
            tablePrefix +
            "state_legislative_districts dm WHERE dm.geo_id in ('" +
            targetInfo["values"].join("','") +
            "') and sld='U' ORDER BY name;";
        }
        queriesArr.push({
          query: senateQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_house_districts") {
        let houseQuery =
          "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
          tablePrefix +
          "state_legislative_districts dm WHERE dm.geo_id in ('" +
          targetInfo["values"].join("','") +
          "') and sld='L' GROUP BY dm.geo_id,dm.state_code,district ORDER BY name;";

        if (DATASOURCE_CONFIG.DATASOURCE == "mysql") {
          houseQuery =
            "SELECT dm.geo_id AS id,CONCAT(dm.state_code, '-',dm.name) AS name ,dm.latitude as lat,dm.longitude as lng FROM " +
            tablePrefix +
            "state_legislative_districts dm WHERE dm.geo_id in ('" +
            targetInfo["values"].join("','") +
            "') and sld='L' ORDER BY name;";
        }
        queriesArr.push({
          query: houseQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_pubs") {
        //console.log("I am inside");
        let pubquery =
          "select id,pub_code, name from " +
          tablePrefix +
          "publishers where pub_code in ('" +
          targetInfo["values"].join("','").replaceAll("account_", "") +
          "') and active='1'";

        let accountsQuery =
          "select a.id,CONCAT('account_',a.id) AS pub_code,CONCAT(a.company,' - ',a.name) AS name from " +
          tablePrefix +
          "accounts as a" +
          " where a.id IN('" +
          targetInfo["values"].join("','").replaceAll("account_", "") +
          "')";

        let finalPubQuery =
          "SELECT id,pub_code,name FROM ((" +
          pubquery +
          ") union (" +
          accountsQuery +
          ")) A";

        queriesArr.push({
          query: finalPubQuery,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_groups") {
        queriesArr.push({
          query:
            "select id,name,type from " +
            tablePrefix +
            "targeting_groups where id in ('" +
            targetInfo["values"].join("','") +
            "') ;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_email_groups") {
        queriesArr.push({
          query:
            "select id,CONCAT(CONCAT(CONCAT(name, ' [', id),'] [',type),']') AS name,type from " +
            tablePrefix +
            "targeting_groups where id in ('" +
            targetInfo["values"].join("','") +
            "') ;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      // else if (targetInfo.key == "target_placements") {
      //   queriesArr.push({
      //     query:
      //       "select id, name,pub_code from consent.publisher_placements WHERE id in ('" +
      //       targetInfo["values"].join("','") +
      //       "') ",
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCampaignLocationChildTablesDataThunk = createAsyncThunk(
  "company/GetCampaignLocationChildTablesDataThunk",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var childInfo = payload[i];
      if (childInfo.key == "target_addresses") {
        queriesArr.push({
          query:
            "select addresses as target_addresses,type from " +
            tablePrefix +
            "campaigns_location_groups_addresses where location_group_id='" +
            childInfo.id +
            "';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_latlon") {
        queriesArr.push({
          query:
            "select id,target_latlon_groups as target_latlon,type from " +
            tablePrefix +
            "campaigns_location_groups_latlon where location_group_id='" +
            childInfo.id +
            "' and is_active=1;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_polygon") {
        queriesArr.push({
          query:
            "select id,target_polygon_groups as target_polygon,type from " +
            tablePrefix +
            "campaigns_location_groups_polygons where location_group_id='" +
            childInfo.id +
            "' and is_active=1;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_poi") {
        // Need to change query
        queriesArr.push({
          /*query:"select bd.id as brand_id,bd.id, bd.name as brand,bd.location_count from aggdata.lists as bd,consent.campaigns_location_groups_poi as poi where  bd.id=poi.target_poi and poi.location_group_id='" +
            childInfo.id +
            "';",*/
          query:
            "select target_poi from " +
            tablePrefix +
            "campaigns_location_groups_poi  where location_group_id='" +
            childInfo.id +
            "' and is_active='1'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
    }
    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

const prepareBannerQueries = (bannerFieldsInfo, campaignId, userDetails) => {
  /*var bannerFieldsInfo = payload.formInfo;
  var campaignId = payload.campaign_id;
  */

  let InsertUpdateQuery = [];
  let InsertQuery =
    "Insert into " +
    tablePrefix +
    "banners (id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,creation_date,updated,created_by,activate_time,expire_time,imp_type,has_campaign_targeting,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,custom_scripts) values";

  /*let InsertQueryWithTargeting =
    "Insert into " +
    tablePrefix +
    "banners (id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,creation_date,updated,target_age," +
    "target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language," +
    "target_cats,target_pubs," +
    "" +
    "target_placements,target_supply_deal_id,target_bundles,created_by,activate_time,expire_time,imp_type,has_campaign_targeting,target_skippable," +
    "target_segments,segments_conditions,segments_conditions_ui) values";
*/
  let InsertQueryValues = [];
  let placementsQueriesArr = [];
  let locationGroupQueriesArr = [];
  let InsertBannerTargetignQueryValues = [];
  var bannerIdArr = [];
  for (var n = 0; n < bannerFieldsInfo.length; n++) {
    var bannerInfo = bannerFieldsInfo[n];
    console.log("Banners Info:", bannerInfo);
    // let TargetingInfo =
    //   bannerInfo?.isTargetingSetLoaded == true && bannerInfo?.targetingSets
    //     ? bannerInfo.targetingSets
    //     : {};

    if (bannerInfo.action == "add") {
      /*if (
        bannerInfo?.isTargetingSetLoaded == true &&
        Object.keys(TargetingInfo).length > 0
      ) {
        bannerIdArr.push(bannerInfo.id);
        //target_segments,segments_conditions,segments_conditions_ui
        InsertBannerTargetignQueryValues.push(
          "('" +
            bannerInfo.id +
            "','" +
            addslashes(bannerInfo.name) +
            "','" +
            campaignId +
            "','" +
            bannerInfo.status +
            "','" +
            bannerInfo.template_type +
            "','" +
            bannerInfo.target_size +
            "','" +
            addslashes(bannerInfo.html) +
            "','" +
            bannerInfo.cache_expiry +
            "','" +
            bannerInfo.iURL +
            "'," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            "," +
            DATASOURCE_CONFIG.CURRENT_DATE +
            ",'" +
            TargetingInfo.target_age +
            "','" +
            TargetingInfo.target_gender +
            "','" +
            TargetingInfo.target_connectiontype +
            "','" +
            TargetingInfo.target_device_os +
            "','" +
            TargetingInfo.target_devicetype +
            "','" +
            TargetingInfo.target_orientation +
            "','" +
            TargetingInfo.target_app +
            "','" +
            TargetingInfo.target_app_language +
            "','" +
            TargetingInfo.target_cats +
            "','" +
            TargetingInfo.target_pubs +
            "','" +
            TargetingInfo.daily_click_cap +
            "','" +
            TargetingInfo.daily_conversion_cap +
            "','" +
            TargetingInfo.daily_impression_cap +
            "','" +
            TargetingInfo.total_click_cap +
            "','" +
            TargetingInfo.total_conversion_cap +
            "','" +
            TargetingInfo.total_impression_cap +
            "','" +
            TargetingInfo.monthly_impression_cap +
            "','" +
            TargetingInfo.monthly_click_cap +
            "','" +
            TargetingInfo.monthly_conversion_cap +
            "','" +
            TargetingInfo.manual_daily_limits +
            "','" +
            TargetingInfo.goals_type_ui +
            "','" +
            TargetingInfo.target_placements +
            "','" +
            TargetingInfo.target_supply_deal_id +
            "','" +
            TargetingInfo.target_bundles +
            "','" +
            bannerInfo.created_by +
            "','0000-00-00 00:00:00','0000-00-00 00:00:00','" +
            bannerInfo.imp_type +
            "','" +
            bannerInfo.has_campaign_targeting +
            "','" +
            TargetingInfo.target_skippable +
            "','" +
            addslashes(TargetingInfo.target_segments) +
            "','" +
            addslashes(TargetingInfo.segments_conditions) +
            "','" +
            addslashes(TargetingInfo.segments_conditions_ui) +
            "')"
        );
       
        if (TargetingInfo?.location_group?.length > 0) {
          let locQuerysRes = prepareBannerLocationGroupQuiries({
            formInfo: TargetingInfo?.location_group,
            created_by: bannerInfo.created_by,
            banner_id: bannerInfo.id,
            action: "add",
            user_details: userDetails,
          });
          if (locQuerysRes.length > 0) {
            locationGroupQueriesArr =
              locationGroupQueriesArr.concat(locQuerysRes);
          }
        }

        //prepareBannerLocationGroupQuiries();
        // prepareBannerPlacemnetQueries(InventoryData, bannerId, type);
      } else {*/
      bannerIdArr.push(bannerInfo.id);
      InsertQueryValues.push(
        "('" +
          bannerInfo.id +
          "','" +
          addslashes(bannerInfo.name) +
          "','" +
          campaignId +
          "','" +
          bannerInfo.status +
          "','" +
          bannerInfo.template_type +
          "','" +
          bannerInfo.target_size +
          "','" +
          addslashes(bannerInfo.html) +
          "','" +
          bannerInfo.cache_expiry +
          "','" +
          bannerInfo.iURL +
          "'," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          "," +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",'" +
          bannerInfo.created_by +
          "','0000-00-00 00:00:00','0000-00-00 00:00:00','" +
          bannerInfo.imp_type +
          "','" +
          bannerInfo.has_campaign_targeting +
          "','" +
          bannerInfo.daily_click_cap +
          "','" +
          bannerInfo.daily_conversion_cap +
          "','" +
          bannerInfo.daily_impression_cap +
          "','" +
          bannerInfo.total_click_cap +
          "','" +
          bannerInfo.total_conversion_cap +
          "','" +
          bannerInfo.total_impression_cap +
          "','" +
          bannerInfo.monthly_impression_cap +
          "','" +
          bannerInfo.monthly_click_cap +
          "','" +
          bannerInfo.monthly_conversion_cap +
          "','" +
          bannerInfo.manual_daily_limits +
          "','" +
          bannerInfo.goals_type_ui +
          "','" +
          bannerInfo.custom_scripts +
          "')"
      );
      //}
    } else if (bannerInfo.action == "delete") {
      InsertUpdateQuery.push({
        query:
          "update " +
          tablePrefix +
          "banners set status='2',updated=" +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " where id='" +
          bannerInfo.id +
          "'",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
        audit: 1,
        audit_details: {
          table: "banners",
          columns:
            "id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,target_age,target_gender,target_device_os,target_devicetype,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,imp_type,target_skippable,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours",
          id: bannerInfo.id,
          context: "banners",
          user_details: userDetails,
        },
      });
    } else if (bannerInfo.action == "edit") {
      let TargetingSetFields = "";
      let targetingColumns = "";
      /*if (
        bannerInfo?.isTargetingSetLoaded == true &&
        Object.keys(TargetingInfo).length > 0
      ) {
        TargetingSetFields =
          ",target_age='" +
          TargetingInfo.target_age +
          "',target_gender='" +
          TargetingInfo.target_gender +
          "',target_connectiontype='" +
          TargetingInfo.target_connectiontype +
          "',target_device_os='" +
          TargetingInfo.target_device_os +
          "',target_devicetype='" +
          TargetingInfo.target_devicetype +
          "',target_orientation='" +
          TargetingInfo.target_orientation +
          "',target_app='" +
          TargetingInfo.target_app +
          "',target_app_language='" +
          TargetingInfo.target_app_language +
          "',target_cats='" +
          TargetingInfo.target_cats +
          "',target_pubs='" +
          TargetingInfo.target_pubs +
          "',daily_click_cap='" +
          TargetingInfo.daily_click_cap +
          "',daily_conversion_cap='" +
          TargetingInfo.daily_conversion_cap +
          "',daily_impression_cap='" +
          TargetingInfo.daily_impression_cap +
          "',total_click_cap='" +
          TargetingInfo.total_click_cap +
          "',total_conversion_cap='" +
          TargetingInfo.total_conversion_cap +
          "',total_impression_cap='" +
          TargetingInfo.total_impression_cap +
          "',monthly_impression_cap='" +
          TargetingInfo.monthly_impression_cap +
          "',monthly_click_cap='" +
          TargetingInfo.monthly_click_cap +
          "',monthly_conversion_cap='" +
          TargetingInfo.monthly_conversion_cap +
          "',manual_daily_limits='" +
          TargetingInfo.manual_daily_limits +
          "',goals_type_ui='" +
          TargetingInfo.goals_type_ui +
          "',target_placements='" +
          TargetingInfo.target_placements +
          "',target_supply_deal_id='" +
          TargetingInfo.target_supply_deal_id +
          "',target_bundles='" +
          TargetingInfo.target_bundles +
          "',target_skippable='" +
          TargetingInfo.target_skippable +
          "',target_segments='" +
          addslashes(TargetingInfo.target_segments) +
          "',segments_conditions='" +
          addslashes(TargetingInfo.segments_conditions) +
          "',segments_conditions_ui='" +
          addslashes(TargetingInfo.segments_conditions_ui) +
          "'";
        targetingColumns =
          ",target_age,target_gender,target_device_os,target_devicetype,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,imp_type,target_skippable,target_segments,segments_conditions,segments_conditions_ui";
        if (TargetingInfo?.location_group?.length > 0) {
          let locQuerysRes = prepareBannerLocationGroupQuiries({
            formInfo: TargetingInfo?.location_group,
            banner_id: bannerInfo.id,
            created_by: bannerInfo.created_by,
            action: "edit",
            user_details: userDetails,
          });
          if (locQuerysRes.length > 0) {
            locationGroupQueriesArr =
              locationGroupQueriesArr.concat(locQuerysRes);
          }
        }
      }*/

      InsertUpdateQuery.push({
        query:
          "update " +
          tablePrefix +
          "banners set name='" +
          addslashes(bannerInfo.name) +
          "',target_size='" +
          bannerInfo.target_size +
          "',html='" +
          addslashes(bannerInfo.html) +
          "',cache_expiry='" +
          bannerInfo.cache_expiry +
          "',iurl='" +
          bannerInfo.iURL +
          "',updated=" +
          DATASOURCE_CONFIG.CURRENT_DATE +
          " " +
          TargetingSetFields +
          ",updated=" +
          DATASOURCE_CONFIG.CURRENT_DATE +
          ",daily_click_cap='" +
          bannerInfo.daily_click_cap +
          "',daily_conversion_cap='" +
          bannerInfo.daily_conversion_cap +
          "',daily_impression_cap='" +
          bannerInfo.daily_impression_cap +
          "',total_click_cap='" +
          bannerInfo.total_click_cap +
          "',total_conversion_cap='" +
          bannerInfo.total_conversion_cap +
          "',total_impression_cap='" +
          bannerInfo.total_impression_cap +
          "',monthly_impression_cap='" +
          bannerInfo.monthly_impression_cap +
          "',monthly_click_cap='" +
          bannerInfo.monthly_click_cap +
          "',monthly_conversion_cap='" +
          bannerInfo.monthly_conversion_cap +
          "',manual_daily_limits='" +
          bannerInfo.manual_daily_limits +
          "',goals_type_ui='" +
          bannerInfo.goals_type_ui +
          "',custom_scripts='" +
          bannerInfo.custom_scripts +
          "'  where id='" +
          bannerInfo.id +
          "'",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
        audit: 1,
        audit_details: {
          table: "banners",
          columns:
            "id,name,template_type,target_size,html,cache_expiry,iurl,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,custom_scripts",
          id: bannerInfo.id,
          user_details: userDetails,
          context: "banners",
        },
      });
    }

    /***Targeting Set Queries** */
  }

  if (InsertQueryValues.length > 0) {
    InsertQuery += InsertQueryValues.join(",");
    InsertUpdateQuery.push({
      query: InsertQuery,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      audit: 1,
      audit_details: {
        table: "banners",
        columns:
          "id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,custom_scripts",
        id: bannerIdArr.length > 0 ? bannerIdArr.join(",") : "",
        user_details: userDetails,
        context: "banners",
      },
    });
  }

  /*if (InsertBannerTargetignQueryValues.length > 0) {
    InsertQueryWithTargeting += InsertBannerTargetignQueryValues.join(",");
    InsertUpdateQuery.push({
      query: InsertQueryWithTargeting,
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      audit: 1,
      audit_details: {
        table: "banners",
        columns:
          "id,name,campaignid,status,template_type,target_size,html,cache_expiry,iurl,target_age,target_gender,target_device_os,target_devicetype,target_app,target_app_language,target_cats,target_pubs,daily_click_cap,daily_conversion_cap,daily_impression_cap,total_click_cap,total_conversion_cap,total_impression_cap,monthly_impression_cap,monthly_click_cap,monthly_conversion_cap,manual_daily_limits,goals_type_ui,target_placements,target_supply_deal_id,target_bundles,created_by,imp_type,target_skippable,target_segments,segments_conditions,segments_conditions_ui",
        id: bannerIdArr.length > 0 ? bannerIdArr.join(",") : "",
        user_details: userDetails,
        context: "banners",
      },
    });
  }*/
  /***Concat Placement Queries */
  if (placementsQueriesArr.length > 0) {
    InsertUpdateQuery = InsertUpdateQuery.concat(placementsQueriesArr);
  }

  /***Concat Location Group Queries* */
  if (locationGroupQueriesArr.length > 0) {
    InsertUpdateQuery = InsertUpdateQuery.concat(locationGroupQueriesArr);
  }
  return InsertUpdateQuery;
};

export const GetBannerDetailsThunk = createAsyncThunk(
  "company/GetBannerDetailsThunk",
  async (payload) => {
    var campaignId = payload.campaign_id;
    const queryBody = {
      queries: [
        {
          query:
            "select * from " +
            tablePrefix +
            "banners where campaignid='" +
            campaignId +
            "' and status !=2  ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetBannerTargetingDetailsThunk = createAsyncThunk(
  "company/GetBannerTargetingDetailsThunk",
  async (payload) => {
    var bannerId = payload.banner_id;
    const queryBody = {
      queries: [
        {
          query:
            "select id,name,target_age,target_gender,target_connectiontype,target_device_os,target_devicetype,target_orientation,target_app,target_app_language,target_cats,target_pubs,target_placements,target_supply_deal_id,target_bundles,target_skippable,target_segments,segments_conditions,segments_conditions_ui,has_campaign_targeting,target_days,target_hours from " +
            tablePrefix +
            "banners where id='" +
            bannerId +
            "' and status !=2  ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          /****get banner location groups data** */
          query:
            "select * from " +
            tablePrefix +
            "banners_location_groups where banner_id='" +
            bannerId +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const UpdateBannerStatusThunk = createAsyncThunk(
  "company/UpdateBannerStatusThunk",
  async (payload) => {
    var bannerId = payload.id;
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "banners set status='" +
            payload.status +
            "',updated=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where id='" +
            bannerId +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "banners",
            columns: "status",
            id: bannerId,
            user_details: payload.user_details,
            context: "banners",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const CreateUpdateDomainIAB = createAsyncThunk(
  "company/CreateUpdateDomainIAB",
  async (payload) => {
    const queryBody = {
      datasource: DATASOURCE_CONFIG.DATASOURCE,
      domain: payload.domain,
      iab_category: payload.iab_category,
    };
    try {
      const response = await axiosApiInstance.post(
        createUpdateDomainIABEndpoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

/*export const GetBannerLocationGroupThunk = createAsyncThunk(
  "campaign/GetBannerLocationGroupThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
         
          query:
            "select * from " +
            tablePrefix +
            "banners_location_groups where banner_id='" +
            payload.id +
            "' and is_active=1",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);*/
/*export const GetBannerInventoryDataThunk = createAsyncThunk(
  "campaign/GetBannerInventoryDataThunk",
  async (payload) => {
    var queriesArr = [
      {
        query:
          "select pp.id, pp.name,pp.pub_code,bp.is_included from " +
          tablePrefix +
          "publisher_placements as pp," +
          tablePrefix +
          "banners_placements bp WHERE pp.id=" +
          DATASOURCE_CONFIG.REGEX +
          "(bp.target_placements, '!','') and bp.banner_id ='" +
          payload.id +
          "' ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
      {
       
        query:
          "select sd.dealid as id, sd.name,cs.is_included from " +
          tablePrefix +
          "rtb_deals_supply as sd," +
          tablePrefix +
          "banners_supply_deals cs WHERE sd.dealid=" +
          DATASOURCE_CONFIG.REGEX +
          "(cs.supply_deal_id, '!','') and cs.banner_id ='" +
          payload.id +
          "' ",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      },
    ];

    if (payload?.pub_code && payload.pub_code.length) {
      queriesArr.push({
        query:
          "select id,pub_code, name from " +
          tablePrefix +
          "publishers where pub_code in ('" +
          payload.pub_code.join("','") +
          "') and active='1' ;",
        datasource: DATASOURCE_CONFIG.DATASOURCE,
      });
    }
    const queryBody = {
      queries: queriesArr,
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);*/
/*export const GetBannerTargetingsByIds = createAsyncThunk(
  "campaign/GetBannerTargetingsByIds",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var targetInfo = payload[i];
      if (targetInfo.key == "target_city") {
        queriesArr.push({
          query:
            "select concat(concat(concat(concat(country_code, '_'), state_code), '_'), Name),id, latitude as lat, longitude as lng, concat(concat(concat((Name), ' '), state_code), ' (CITY)') as Name,'city' as type from " +
            tablePrefix +
            "cities where id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_state") {
        queriesArr.push({
          query:
            "select concat(concat(country_code, '_'), iso2) as state_code,id,  concat(name,' (STATE)') as Name, latitude as lat, longitude as lng,'state' as type from " +
            tablePrefix +
            "states where id in ('" +
            targetInfo["values"].join("','") +
            "') ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_dma") {
        queriesArr.push({
          query:
            "select dma_code,dma_code as id, concat(dma_name,' (DMA)') as name,0 as lat,0 as lng,'dma' as type from " +
            tablePrefix +
            "geodma where dma_code in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_counties") {
        queriesArr.push({
          query:
            "select id as county_code, concat(concat(county_name, ' '), state) as name from " +
            tablePrefix +
            "counties where id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "brands") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_poi") {
        queriesArr.push({
          query:
            "select id as brand_id,id, name as brand,location_count from aggdata.lists where  id in ('" +
            targetInfo["values"].join("','") +
            "')",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_congressional_districts") {
        queriesArr.push({
          query:
            "SELECT dm.id AS id,concat(concat(state_code, '-'), cd116_fip) AS name,0 as lat,0 as lng FROM " +
            tablePrefix +
            "congressional_districts dm where  id in ('" +
            targetInfo["values"].join("','") +
            "') GROUP BY dm.id,dm.state_code, cd116_fip  ORDER BY name",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_senate_districts") {
        queriesArr.push({
          query:
            "SELECT dm.geo_id AS id,concat(concat(state_code, '('), concat(district,')')) AS name ,0 as lat,0 as lng FROM " +
            tablePrefix +
            "state_legislative_districts dm WHERE dm.geo_id in ('" +
            targetInfo["values"].join("','") +
            "') GROUP BY dm.geo_id,dm.state_code,district ORDER BY name;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (targetInfo.key == "target_pubs") {
        queriesArr.push({
          query:
            "select id,pub_code, name from " +
            tablePrefix +
            "publishers where pub_code in ('" +
            targetInfo["values"].join("','") +
            "') and active='1';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      }
      // else if (targetInfo.key == "target_placements") {
      //   queriesArr.push({
      //     query:
      //       "select id, name,pub_code from consent.publisher_placements WHERE id in ('" +
      //       targetInfo["values"].join("','") +
      //       "') ",
      //     datasource: DATASOURCE_CONFIG.DATASOURCE,
      //   });
      // }
    }

    const queryBody = {
      queries: queriesArr,
    };

    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
*/
/*export const GetBannerLocationChildTablesDataThunk = createAsyncThunk(
  "campaign/GetBannerLocationChildTablesDataThunk",
  async (payload) => {
    var queriesArr = [];
    for (var i = 0; i < payload.length; i++) {
      var childInfo = payload[i];
      if (childInfo.key == "target_addresses") {
        queriesArr.push({
          query:
            "select addresses as target_addresses,type from " +
            tablePrefix +
            "banners_location_groups_addresses where location_group_id='" +
            childInfo.id +
            "';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_latlon") {
        queriesArr.push({
          query:
            "select id,target_latlon_groups as target_latlon,type from " +
            tablePrefix +
            "banners_location_groups_latlon where location_group_id='" +
            childInfo.id +
            "' and is_active=1;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_polygon") {
        queriesArr.push({
          query:
            "select id,target_polygon_groups as target_polygon,type from " +
            tablePrefix +
            "banners_location_groups_polygons where location_group_id='" +
            childInfo.id +
            "' and is_active=1;",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
      } else if (childInfo.key == "target_poi") {
       
        queriesArr.push({
          query:
            "select target_poi from " +
            tablePrefix +
            "banners_location_groups_poi  where location_group_id='" +
            childInfo.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        });
        console.log("POI Query:", queriesArr);
      }
    }
    const queryBody = {
      queries: queriesArr,
    };
    console.log("Child Table Query", queryBody);
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);*/

export const UpdateCampaignStatusThunk = createAsyncThunk(
  "campaign/UpdateCampaignStatusThunk",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "update " +
            tablePrefix +
            "campaigns set status='" +
            payload.status +
            "',updated=" +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " where id='" +
            payload.id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
          audit: 1,
          audit_details: {
            table: "campaigns",
            columns: "status",
            id: payload.id,
            user_details: payload.user_details,
            context: "campaigns",
          },
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const PinUnPinCampaignThunk = createAsyncThunk(
  "campaign/PinUnPinCampaignThunk",
  async (payload) => {
    let query = "";
    if (payload.action == "pin") {
      query =
        "insert into pinned_campaigns (campaignid,userid) values('" +
        payload.campaignId +
        "','" +
        payload.userId +
        "');";
    } else {
      query =
        "Delete from pinned_campaigns where campaignid='" +
        payload.campaignId +
        "' and userid='" +
        payload.userId +
        "';";
    }
    const queryBody = {
      queries: [
        {
          query: query,
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(
        updateDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCopyCampaignDetails = createAsyncThunk(
  "company/GetCopyCampaignDetails",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select name as location_group_name,id as location_group_id from " +
            tablePrefix +
            "campaigns_location_groups clg where is_active=1 and campaign_id='" +
            payload.campaign_id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select name as banner_name,id as banner_id from " +
            tablePrefix +
            "banners where status!=2 and campaignid='" +
            payload.campaign_id +
            "';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
        {
          query:
            "select blg.id as location_group_id,blg.name as location_group_name,b.id as banner_id from " +
            tablePrefix +
            "banners as b, " +
            tablePrefix +
            "banners_location_groups as blg where b.id=blg.banner_id AND b.status !=2 and b.campaignid='" +
            payload.campaign_id +
            "';",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetCopyCampaignBannerTargetingDetails = createAsyncThunk(
  "company/GetCopyCampaignBannerTargetingDetails",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select name as banner_location_group_name,id as banner_location_group_id from " +
            tablePrefix +
            "banners_location_groups clg where is_active=1 and banner_id='" +
            payload.banner_id +
            "'",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetProvidersListThunk = createAsyncThunk(
  "company/GetProvidersListThunk",
  async (payload) => {
    let getOnlyLimitedProviders =
      " and code IN ('" + Providers.join("','") + "')";
    if (payload && payload?.is_sys_admin != 1) {
      let providersArr = normalizeAudienceProviderCodes(payload);
      getOnlyLimitedProviders =
        " and code IN ('" + providersArr.join("','") + "')";
    }
    const queryBody = {
      queries: [
        {
          query:
            "SELECT code,name,email,address,is_external,cookie_sync_url,description from " +
            tablePrefix +
            "audience_provider_details where active=1 " +
            getOnlyLimitedProviders +
            " ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetLatLongGroupsListThunk = createAsyncThunk(
  "company/GetLatLongGroupsListThunk",
  async (payload) => {
    var searchText = payload.searchText;
    let selGroups = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selGroups.push(info.id);
      }
    }
    let where =
      selGroups.length > 0
        ? " and id NOT IN('" + selGroups.join("','") + "')"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "SELECT id,name from " +
            tablePrefix +
            "targeting_groups where  type='latlon' and name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' " +
            where +
            " limit 5",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetZipcodeGroupsListThunk = createAsyncThunk(
  "company/GetZipcodeGroupsListThunk",
  async (payload) => {
    var searchText = payload.searchText;
    let selGroups = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selGroups.push(info.id);
      }
    }
    let where =
      selGroups.length > 0
        ? " and id NOT IN('" + selGroups.join("','") + "')"
        : "";

    const queryBody = {
      queries: [
        {
          query:
            "SELECT id,name from " +
            tablePrefix +
            "targeting_groups where  type='zipcode' and name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' " +
            where +
            " limit 5",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetEmailGroupsListThunk = createAsyncThunk(
  "company/GetEmailGroupsListThunk",
  async (payload) => {
    var searchText = payload.searchText;
    let selGroups = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selGroups.push(info.id);
      }
    }
    let where =
      selGroups.length > 0
        ? " and id NOT IN('" + selGroups.join("','") + "')"
        : "";

    const queryBody = {
      queries: [
        {
          query:
            "SELECT id,CONCAT(CONCAT(CONCAT(name, ' [', id),'] [',type),']') AS name from " +
            tablePrefix +
            "targeting_groups where  type IN('email','email_sha2_256_lower','email_sha2_256_upper') and name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' " +
            where +
            " limit 5",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetPolygonGroupsListThunk = createAsyncThunk(
  "company/GetPolygonGroupsListThunk",
  async (payload) => {
    var searchText = payload.searchText;
    let selGroups = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selGroups.push(info.id);
      }
    }
    let where =
      selGroups.length > 0
        ? " and id NOT IN('" + selGroups.join("','") + "')"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "SELECT id,name from " +
            tablePrefix +
            "targeting_groups where  type='polygon' and name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' " +
            where +
            " limit 5",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetAddressGroupsListThunk = createAsyncThunk(
  "company/GetAddressGroupsListThunk",
  async (payload) => {
    var searchText = payload.searchText;
    let selGroups = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selGroups.push(info.id);
      }
    }
    let where =
      selGroups.length > 0
        ? " and id NOT IN('" + selGroups.join("','") + "')"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "SELECT id,name from " +
            tablePrefix +
            "targeting_groups where  type='address' and name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' " +
            where +
            "  limit 5",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetIPAddressGroupsListThunk = createAsyncThunk(
  "company/GetIPAddressGroupsListThunk",
  async (payload) => {
    var searchText = payload.searchText;
    let selGroups = [];
    var selectedValuesArr = payload?.selValue ? payload?.selValue : [];
    for (let x = 0; x < selectedValuesArr.length; x++) {
      let info = selectedValuesArr[x];
      if (info?.id) {
        selGroups.push(info.id);
      }
    }
    let where =
      selGroups.length > 0
        ? " and id NOT IN('" + selGroups.join("','") + "')"
        : "";
    const queryBody = {
      queries: [
        {
          query:
            "SELECT id,name from " +
            tablePrefix +
            "targeting_groups where  type='ipaddress' and name " +
            DATASOURCE_CONFIG.QUERY_LIKE +
            " '%" +
            searchText +
            "%' " +
            where +
            "  limit 5",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetCampaignReportDataThunk = createAsyncThunk(
  "campaign/GetCampaignReportDataThunk",
  async (payload) => {
    let start_date = payload.start_date;
    let end_date = payload.end_date;
    let userTimeZone = payload.timezone;
    let campaignId = payload.campaignId;

    //Getting current UTC time.
    start_date = moment
      .utc()
      .subtract(24, "hours")
      .format("YYYY-MM-DD HH:mm:ss");
    end_date = moment.utc().format("YYYY-MM-DD HH:mm:ss");

    //Converting UTC Time to User Timezone
    start_date = moment
      .tz(start_date, "YYYY-MM-DD HH:mm:ss", "UTC")
      .tz(userTimeZone)
      .format("YYYY-MM-DD HH:mm:ss");

    end_date = moment
      .tz(end_date, "YYYY-MM-DD HH:mm:ss", "UTC")
      .tz(userTimeZone)
      .format("YYYY-MM-DD HH:mm:ss");

    let WC = [];
    WC.push(
      `datehour >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') and datehour < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') AND (hourly."segment" IN('${campaignId}')) Group by date, ui_date, hr order by date asc`
    );
    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }
    var q =
      "SELECT  SUM(hourly.requestcount) as available,SUM(hourly.cardinality) as uniques,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', datehour),'HH24') as hr ,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', datehour),'MM/DD HH24') as date  ,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', datehour),'HH24') as ui_date  from consent.campaigns_adserv_hourly_realtime_avails as hourly " +
      whrCondition +
      " ";

    const queryBody = {
      queries: [
        {
          query: q,
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const GetSupplyReportDataThunk = createAsyncThunk(
  "supply/GetSupplyReportDataThunk",
  async (payload) => {
    let start_date = payload.start_date;
    let end_date = payload.end_date;
    let userTimeZone = payload.timezone;
    let supplyId = payload.supplyId;

    //Getting current UTC time.
    start_date = moment
      .utc()
      .subtract(24, "hours")
      .format("YYYY-MM-DD HH:mm:ss");
    end_date = moment.utc().format("YYYY-MM-DD HH:mm:ss");

    //Converting UTC Time to User Timezone
    start_date = moment
      .tz(start_date, "YYYY-MM-DD HH:mm:ss", "UTC")
      .tz(userTimeZone)
      .format("YYYY-MM-DD HH:mm:ss");

    end_date = moment
      .tz(end_date, "YYYY-MM-DD HH:mm:ss", "UTC")
      .tz(userTimeZone)
      .format("YYYY-MM-DD HH:mm:ss");

    let WC = [];
    WC.push(
      `datehour >= CONVERT_TIMEZONE('${userTimeZone}','UTC','${start_date}') and datehour < CONVERT_TIMEZONE('${userTimeZone}','UTC','${end_date}') AND (hourly."segment" IN('${supplyId}')) Group by date, ui_date, hr order by date asc`
    );
    let whrCondition = "";
    if (WC.length > 0) {
      whrCondition = " where " + WC.join(" and ");
    }
    var q =
      "SELECT  SUM(hourly.requestcount) as available,SUM(hourly.cardinality) as uniques,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', datehour),'HH24') as hr ,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', datehour),'MM/DD HH24') as date  ,TO_CHAR(CONVERT_TIMEZONE('UTC', '" +
      userTimeZone +
      "', datehour),'HH24') as ui_date  from consent.supply_adserv_hourly_realtime_avails as hourly " +
      whrCondition +
      "";

    const queryBody = {
      queries: [
        {
          query: q,
          datasource: "redshift",
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const GetAllCampaignBidPriceListThunk = createAsyncThunk(
  "campaign/GetAllCampaignBidPriceListThunk",
  async (payload) => {
    const queryBody = {
      userData: {
        is_sys_admin: payload?.authUserData?.is_sys_admin,
        user_id: payload?.authUserData?.user_id,
        show_pub_names:
          payload?.authUserData?.user_permissions?.includes("show_pub_names") ==
          true
            ? 1
            : 0,
      },
    };

    try {
      const response = await axiosApiInstance.post(
        getCampaignBidPriceDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const UpdateAllCampaignBidPriceThunk = createAsyncThunk(
  "campaign/UpdateAllCampaignBidPriceThunk",
  async (payload) => {
    const queryBody = {
      bidprice_info: payload?.bidprice_info ? payload?.bidprice_info : {},
      campaigns: payload?.campaigns ? payload?.campaigns : [],
    };

    try {
      const response = await axiosApiInstance.post(
        updateCampaignBidPriceDataEndPoint,
        queryBody
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);

export const getAllEligibleFutureTargetingCampaigns = createAsyncThunk(
  "campaign/getAllEligibleFutureTargetingCampaigns",
  async (payload) => {
    let advertiserArr = [];
    let advertisersList = payload.advertiserList;

    advertisersList.map((info) => {
      advertiserArr.push(info.value);
    });

    const queryBody = {
      queries: [
        {
          query:
            "select id,name,status from " +
            tablePrefix +
            "campaigns where advertiserid IN ('" +
            advertiserArr.join("','") +
            "') and future_retargeting=1 and  activate_time > " +
            DATASOURCE_CONFIG.CURRENT_DATE +
            " - " +
            DATASOURCE_CONFIG.CAMPAIGN_EXPIRY_INTERVAL +
            " ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const getHasCampaignTargetingBanners = createAsyncThunk(
  "campaign/getHasCampaignTargetingBanners",
  async (payload) => {
    const queryBody = {
      queries: [
        {
          query:
            "select id,name from " +
            tablePrefix +
            "banners where has_campaign_targeting='1' and campaignid='" +
            payload.campaignId +
            "' and status !=2 ",
          datasource: DATASOURCE_CONFIG.DATASOURCE,
        },
      ],
    };
    try {
      const response = await axiosApiInstance.post(getDataEndPoint, queryBody);
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
export const UpdateCampaignTargetingBannersThunk = createAsyncThunk(
  "campaign/UpdateCampaignTargetingBannersThunk",
  async (payload) => {
    try {
      const response = await axiosApiInstance.post(
        setCampaignBannerTargetingDataEndPoint,
        payload
      );
      //console.log("response", response);
      return response;
    } catch (err) {
      // You can choose to use the message attached to err or write a custom error
      console.log("response", err);
    }
  }
);
const Campaign = createSlice({
  name: "campaign",
  initialState,
  reducers: {
    updateBannerLoader(state, action) {
      state.bannerLoader = action.payload.bannerLoader;
    },
    updateCampaignFiltersFormValues(state, action) {
      let campaignFilters = cloneDeep(state.campaignFilterFormValues);
      if (action.payload?.action == "delete") {
        campaignFilters = {
          accounts: [],
          advertisers: [],
          packages: [],
          campaigns: [],
          status: [],
          startDate: "",
          endDate: "",
        };
      } else {
        let type = action.payload.type;
        let data = action.payload.data;
        campaignFilters[type] = data;
      }

      state.campaignFilterFormValues = campaignFilters;
    },

    updateCampaignFiltersDateValues(state, action) {
      let campaignFilters = cloneDeep(state.campaignFilterFormValues);

      campaignFilters.startDate = action.payload.startDate;
      campaignFilters.endDate = action.payload.endDate;

      state.campaignFilterFormValues = campaignFilters;
    },

    updateCampaignFilters(state, action) {
      let campaignFilters = cloneDeep(state.campaignFilters);
      campaignFilters.accounts = action.payload.accounts;
      campaignFilters.advertisers = action.payload.advertisers;
      campaignFilters.packages = action.payload.packages;
      campaignFilters.campaigns = action.payload.campaigns;
      campaignFilters.status = action.payload.status;
      campaignFilters.startDate = action.payload.startDate;
      campaignFilters.endDate = action.payload.endDate;

      state.campaignFilters = campaignFilters;
    },
    updateCampaignStatusList(state, action) {
      let campaignList = state.CampaignsList;
      let campaignId = action.payload.campaignId;
      let pinAction = action.payload.action;
      let filterStatus = action.payload.filterStatus;
      console.log("pinAction", pinAction, filterStatus);

      if (pinAction == "unpin") {
        if (filterStatus.includes("pin") == true) {
          campaignList = campaignList.filter((item) => item.id !== campaignId);
        } else {
          campaignList.map((info) => {
            if (info.id == campaignId) {
              info.isPinned = pinAction == "pin" ? 1 : 0;
            }
            return info;
          });
        }
      } else {
        if (filterStatus.includes("pin") == true) {
          campaignList.map((info) => {
            if (info.id == campaignId) {
              info.isPinned = pinAction == "pin" ? 1 : 0;
            }
            return info;
          });
        } else {
          campaignList.map((info) => {
            if (info.id == campaignId) {
              info.isPinned = pinAction == "pin" ? 1 : 0;
            }
            return info;
          });
        }
      }

      state.CampaignsList = campaignList;
    },
    //   resetAccountForm(state, action) {
    //     state.accountDetails = {
    //       name: "",
    //       company_id: "",
    //       tag_id: "",
    //       email: "",
    //       phone: "",
    //       address: "",
    //       margin: "",
    //       bc_email: "",
    //       cs_email: "",
    //       po_email: "",
    //       logoUrl: "",
    //       theme: "",
    //     };
    //   },
  },

  extraReducers(builder) {
    builder
      .addCase(CreateUpdateCampaignDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(CreateUpdateCampaignDetailsThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.results.length > 0 &&
          action.payload.data.results.includes("Updated")
        ) {
          //state.accountsDetails = action.payload.data.results[0];
        }
        state.submitLoading = false;
      })
      .addCase(CreateUpdateCampaignDetailsThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.submitLoading = false;
      })
      .addCase(CreateUpdateCampaignLocationDetailsThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(
        CreateUpdateCampaignLocationDetailsThunk.fulfilled,
        (state, action) => {
          if (
            action.payload.data?.results.length > 0 &&
            action.payload.data.results.includes("Updated")
          ) {
            //state.accountsDetails = action.payload.data.results[0];
          }
          state.submitLoading = false;
        }
      )
      .addCase(
        CreateUpdateCampaignLocationDetailsThunk.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.submitLoading = false;
        }
      )
      .addCase(CreateUpdateBannerTargetingThunk.pending, (state) => {
        state.bannerTargetingModalLoading = true;
      })
      .addCase(CreateUpdateBannerTargetingThunk.fulfilled, (state, action) => {
        if (
          action.payload.data?.results.length > 0 &&
          action.payload.data.results.includes("Updated")
        ) {
          //state.accountsDetails = action.payload.data.results[0];
        }
        state.bannerTargetingModalLoading = false;
      })
      .addCase(CreateUpdateBannerTargetingThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.bannerTargetingModalLoading = false;
      })
      .addCase(GetAllCampaignsListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllCampaignsListThunk.fulfilled, (state, action) => {
        //console.log("action.payloadcampaign:", action.payload);
        if (action.payload.data?.error == false) {
          //let data = action.payload.data.results[0];
          let data = action.payload.data.results;
          //console.log("action.payloadcampaign-Inside:", data);
          /*for (let i = 0; i < data.length; i++) {
            var expire_time = data[i]["expire_time"];
            var activate_time = data[i]["activate_time"];
            var currentDate = moment
              .utc(new Date())
              .tz(data[i].trafficking_timezone_country)
              .format("YYYY-MM-DD HH:mm:ss");
            //var currentDate = moment.tz(new Date(), "YYYY-MM-DD HH:mm:ss", data[i].trafficking_timezone_country).utc().format("YYYY-MM-DD HH:mm:ss");
            var status = data[i]["status"];
            var status_type = "";
            if (status == -1) {
              status_type = "draft";
            } else if (status == 0 && activate_time > currentDate) {
              status_type = "schedule";
            } else if (
              status == 0 &&
              ((expire_time != "" &&
                expire_time != null &&
                expire_time > currentDate) ||
                expire_time == "0000-00-00 00:00:00" ||
                expire_time == "" ||
                expire_time == null)
            ) {
              status_type = "active";
            } else if (status == 1) {
              status_type = "pause";
            } else if (
              (expire_time != "" &&
                expire_time != null &&
                expire_time != "0000-00-00 00:00:00" &&
                expire_time < currentDate) ||
              status == 3
            ) {
              status_type = "expire";
            } else if (status == 4) {
              status_type = "approval_pending";
            }

            data[i]["status_type"] = status_type;
          }*/

          state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetAllCampaignsListThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.loading = false;
      })
      .addCase(GetCampaignDetailsThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetCampaignDetailsThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.loading = false;
      })
      .addCase(GetCampaignDetailsThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })
      .addCase(GetCampaignLocationGroupThunk.pending, (state) => {
        state.locationGroupLoading = true;
      })
      .addCase(GetCampaignLocationGroupThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.locationGroupLoading = false;
      })
      .addCase(GetCampaignLocationGroupThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.locationGroupLoading = false;
      })
      .addCase(GetCampaignInventoryDataThunk.pending, (state) => {
        state.CampaignInventoryLoading = true;
      })
      .addCase(GetCampaignInventoryDataThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.CampaignInventoryLoading = false;
      })
      .addCase(GetCampaignInventoryDataThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.CampaignInventoryLoading = false;
      })

      .addCase(GetIABlistFromDomains.pending, (state) => {
        //state.loading = true;
      })
      .addCase(GetIABlistFromDomains.fulfilled, (state, action) => {
        //state.loading = false;
      })
      .addCase(GetIABlistFromDomains.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })
      .addCase(GetTargetingTypeOptionsThunk.pending, (state) => {
        state.isTargetingTypesLoaded = false;
      })
      .addCase(GetTargetingTypeOptionsThunk.fulfilled, (state, action) => {
        //state.loading = false;
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          var targetingOptionsInfo = {};
          for (var k = 0; k < data.length; k++) {
            var optionInfo = data[k];
            if (
              !targetingOptionsInfo.hasOwnProperty(optionInfo.targeting_type)
            ) {
              targetingOptionsInfo[optionInfo.targeting_type] = [];
            }
            targetingOptionsInfo[optionInfo.targeting_type].push(optionInfo);
          }
          state.TargtingTypeOptions = targetingOptionsInfo;
        }
        state.isTargetingTypesLoaded = true;
      })
      .addCase(GetTargetingTypeOptionsThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })
      .addCase(GetCampaignTargetingsByIds.pending, (state) => {
        //state.loading = true;
        state.locationGroupLoading = true;
      })
      .addCase(GetCampaignTargetingsByIds.fulfilled, (state, action) => {
        //state.loading = false;
        state.locationGroupLoading = false;
      })
      .addCase(GetCampaignTargetingsByIds.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.locationGroupLoading = false;
      })
      .addCase(GetCampaignLocationChildTablesDataThunk.pending, (state) => {
        //state.loading = true;
      })
      .addCase(
        GetCampaignLocationChildTablesDataThunk.fulfilled,
        (state, action) => {
          //state.loading = false;
        }
      )
      .addCase(
        GetCampaignLocationChildTablesDataThunk.rejected,
        (state, action) => {
          //toast.error("Something went Wrong!");
        }
      )
      /*.addCase(GetBannerLocationChildTablesDataThunk.pending, (state) => {
        //state.loading = true;
        state.bannerLocationGroupLoading = true;
      })
      .addCase(
        GetBannerLocationChildTablesDataThunk.fulfilled,
        (state, action) => {
          //state.loading = false;
          state.bannerLocationGroupLoading = false;
        }
      )
      .addCase(
        GetBannerLocationChildTablesDataThunk.rejected,
        (state, action) => {
          //toast.error("Something went Wrong!");
        }
      )*/
      /*.addCase(CreateUpdateBannerDetailsThunk.pending, (state) => {
        //state.loading = true;
      })
      .addCase(CreateUpdateBannerDetailsThunk.fulfilled, (state, action) => {
        //state.loading = false;
      })
      .addCase(CreateUpdateBannerDetailsThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
      })*/
      .addCase(GetBannerDetailsThunk.pending, (state) => {
        //state.loading = true;
        state.bannerLoader = true;
      })
      .addCase(GetBannerDetailsThunk.fulfilled, (state, action) => {
        //state.loading = false;
        // state.bannerLoader = false;
      })
      .addCase(GetBannerDetailsThunk.rejected, (state, action) => {
        state.bannerLoader = false;
      })
      .addCase(GetBannerTargetingDetailsThunk.pending, (state) => {
        //state.loading = true;
        state.bannerTargetingModalLoading = true;
      })
      .addCase(GetBannerTargetingDetailsThunk.fulfilled, (state, action) => {
        //state.loading = false;
        state.bannerTargetingModalLoading = false;
      })
      .addCase(GetBannerTargetingDetailsThunk.rejected, (state, action) => {
        state.bannerTargetingModalLoading = false;
      })
      .addCase(CreateUpdateDomainIAB.pending, (state) => {
        //state.loading = true;
      })
      .addCase(CreateUpdateDomainIAB.fulfilled, (state, action) => {
        //state.loading = false;
      })
      .addCase(CreateUpdateDomainIAB.rejected, (state, action) => {})
      /*.addCase(GetBannerLocationGroupThunk.pending, (state) => {
        state.bannerLocationGroupLoading = true;
      })
      .addCase(GetBannerLocationGroupThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.bannerLocationGroupLoading = false;
      })
      .addCase(GetBannerLocationGroupThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.bannerLocationGroupLoading = false;
      })
      .addCase(GetBannerInventoryDataThunk.pending, (state) => {
        state.BannerInventoryLoading = true;
      })
      .addCase(GetBannerInventoryDataThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          let data = action.payload.data.results[0];
          //state.CampaignsList = data;
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.BannerInventoryLoading = false;
      })
      .addCase(GetBannerInventoryDataThunk.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.BannerInventoryLoading = false;
      })*/
      .addCase(UpdateCampaignStatusThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateCampaignStatusThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let campaignList = state.CampaignsList;
          let campaignId = action.meta.arg.id;
          let status = action.meta.arg.status;
          let filterStatus = action.meta.arg.filters;
          if (status == "2") {
            campaignList = campaignList.filter(
              (item) => item.id !== campaignId
            );
          } else {
            if (filterStatus.includes(status) == false) {
              campaignList = campaignList.filter(
                (item) => item.id !== campaignId
              );
            } else {
              campaignList.map((info) => {
                if (info.id == campaignId) {
                  info.status = status;
                  if (status == "1") {
                    info.status_type = "pause";
                  } else if (status == "0") {
                    info.status_type = "active";
                  }
                }
                return info;
              });
            }
          }

          state.CampaignsList = campaignList;
        }
        state.loading = false;
      })
      .addCase(UpdateCampaignStatusThunk.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(PinUnPinCampaignThunk.pending, (state) => {
        // state.loading = true;
      })
      .addCase(PinUnPinCampaignThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error === false) {
          /*let campaignList = state.CampaignsList;
          let campaignId = action.meta.arg.campaignId;
          let pinAction = action.meta.arg.action;

          campaignList.map((info) => {
            if (info.id == campaignId) {
              info.isPinned = pinAction == "pin" ? 1 : 0;
            }
            return info;
          });
          state.CampaignsList = campaignList;
          */
        }
        //state.loading = false;
      })
      .addCase(PinUnPinCampaignThunk.rejected, (state, action) => {
        //state.loading = false;
      })
      .addCase(UpdateBannerStatusThunk.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(UpdateBannerStatusThunk.fulfilled, (state, action) => {
        state.submitLoading = false;
      })
      .addCase(UpdateBannerStatusThunk.rejected, (state, action) => {
        state.submitLoading = false;
      })
      .addCase(GetSegmentsListForTargeting.pending, (state) => {
        state.segmentLoader = true;
      })
      .addCase(GetSegmentsListForTargeting.fulfilled, (state, action) => {
        state.segmentLoader = false;
      })
      .addCase(GetSegmentsListForTargeting.rejected, (state, action) => {
        state.segmentLoader = false;
      })
      .addCase(GetCopyCampaignDetails.pending, (state) => {
        state.copyCampaignLoading = true;
      })
      .addCase(GetCopyCampaignDetails.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }
        state.copyCampaignLoading = false;
      })
      .addCase(GetCopyCampaignDetails.rejected, (state, action) => {
        //toast.error("Something went Wrong!");
        state.copyCampaignLoading = false;
      })
      .addCase(GetCopyCampaignBannerTargetingDetails.pending, (state) => {
        state.copyCampaignLoading = true;
      })
      .addCase(
        GetCopyCampaignBannerTargetingDetails.fulfilled,
        (state, action) => {
          /*if (action.payload.data?.results?.length > 0) {
        } else if (action.payload.data.status == 0) {
          // toast.error(action.payload.data.message);
        }*/
          state.copyCampaignLoading = false;
        }
      )
      .addCase(
        GetCopyCampaignBannerTargetingDetails.rejected,
        (state, action) => {
          //toast.error("Something went Wrong!");
          state.copyCampaignLoading = false;
        }
      )
      .addCase(CreateCopyCampaignThunk.pending, (state) => {
        state.copyCampaignLoading = true;
      })
      .addCase(CreateCopyCampaignThunk.fulfilled, (state, action) => {
        state.copyCampaignLoading = false;
      })
      .addCase(CreateCopyCampaignThunk.rejected, (state, action) => {
        state.copyCampaignLoading = false;
      })
      .addCase(GetCreativeCopyTargetsThunk.pending, (state) => {
        state.creativeCopyLoading = true;
        state.creativeCopyTargets = [];
      })
      .addCase(GetCreativeCopyTargetsThunk.fulfilled, (state, action) => {
        state.creativeCopyLoading = false;
        if (action.payload?.data?.results?.[0]?.length > 0) {
          state.creativeCopyTargets = action.payload.data.results[0];
        }
      })
      .addCase(GetCreativeCopyTargetsThunk.rejected, (state) => {
        state.creativeCopyLoading = false;
        state.creativeCopyTargets = [];
      })
      .addCase(CopyCreativeToCampaignsThunk.pending, (state) => {
        state.creativeCopyLoading = true;
      })
      .addCase(CopyCreativeToCampaignsThunk.fulfilled, (state) => {
        state.creativeCopyLoading = false;
      })
      .addCase(CopyCreativeToCampaignsThunk.rejected, (state) => {
        state.creativeCopyLoading = false;
      })
      .addCase(BulkUpdateCampaignGoalsThunk.pending, (state) => {
        state.bulkGoalUpdateLoading = true;
      })
      .addCase(BulkUpdateCampaignGoalsThunk.fulfilled, (state) => {
        state.bulkGoalUpdateLoading = false;
      })
      .addCase(BulkUpdateCampaignGoalsThunk.rejected, (state) => {
        state.bulkGoalUpdateLoading = false;
      })
      .addCase(GetProvidersListThunk.pending, (state) => {})
      .addCase(GetProvidersListThunk.fulfilled, (state, action) => {
        //state.copyCampaignLoading = false;
        if (action.payload.data?.results?.length > 0) {
          let providersListObj = {};
          let dbList = action.payload.data?.results[0];
          for (let n = 0; n < dbList.length; n++) {
            let providerInfo = dbList[n];
            providersListObj[providerInfo.code] = providerInfo.name;
          }
          normalizeAudienceProviderCodes(action.meta.arg).forEach((provider) => {
            if (
              Providers.includes(provider) &&
              !providersListObj[provider] &&
              ProvidersNameList[provider]
            ) {
              providersListObj[provider] = ProvidersNameList[provider];
            }
          });
          state.providersList = providersListObj;
        }
      })
      .addCase(GetProvidersListThunk.rejected, (state, action) => {
        //state.copyCampaignLoading = false;
      })
      .addCase(GetCampaignReportDataThunk.pending, (state) => {
        state.reportLoading = true;
      })
      .addCase(GetCampaignReportDataThunk.fulfilled, (state, action) => {
        state.reportLoading = false;
      })
      .addCase(GetCampaignReportDataThunk.rejected, (state, action) => {})
      .addCase(GetLatLongGroupsListThunk.pending, (state) => {
        state.searchTargtingGroupLoading = true;
      })
      .addCase(GetLatLongGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          state.latlonGroupsList = action.payload.data?.results[0];
        }
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetLatLongGroupsListThunk.rejected, (state, action) => {})
      .addCase(GetZipcodeGroupsListThunk.pending, (state) => {
        state.searchTargtingGroupLoading = true;
      })
      .addCase(GetZipcodeGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          state.zipcodeGroupsList = action.payload.data?.results[0];
        }
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetZipcodeGroupsListThunk.rejected, (state, action) => {})
      .addCase(GetEmailGroupsListThunk.pending, (state) => {
        state.searchTargtingGroupLoading = true;
      })
      .addCase(GetEmailGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          state.emailGroupsList = action.payload.data?.results[0];
        }
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetEmailGroupsListThunk.rejected, (state, action) => {
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetAddressGroupsListThunk.pending, (state) => {
        state.searchTargtingGroupLoading = true;
      })
      .addCase(GetAddressGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          state.addressGroupsList = action.payload.data?.results[0];
        }
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetAddressGroupsListThunk.rejected, (state, action) => {})

      .addCase(GetIPAddressGroupsListThunk.pending, (state) => {
        state.searchTargtingGroupLoading = true;
      })
      .addCase(GetIPAddressGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          state.ipaddressGroupsList = action.payload.data?.results[0];
        }
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetIPAddressGroupsListThunk.rejected, (state, action) => {})

      .addCase(GetPolygonGroupsListThunk.pending, (state) => {
        state.searchTargtingGroupLoading = true;
      })
      .addCase(GetPolygonGroupsListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results?.length > 0) {
          state.polygonGroupsList = action.payload.data?.results[0];
        }
        state.searchTargtingGroupLoading = false;
      })
      .addCase(GetPolygonGroupsListThunk.rejected, (state, action) => {})
      .addCase(GetSupplyReportDataThunk.pending, (state) => {
        state.reportLoading = true;
      })
      .addCase(GetSupplyReportDataThunk.fulfilled, (state, action) => {
        state.reportLoading = false;
      })
      .addCase(GetSupplyReportDataThunk.rejected, (state, action) => {})
      .addCase(GetAllCampaignBidPriceListThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetAllCampaignBidPriceListThunk.fulfilled, (state, action) => {
        // if (action.payload.data?.results[0]) {
        //   state.demandPartnersList = action.payload.data?.results[0];
        // }
        state.loading = false;
      })
      .addCase(GetAllCampaignBidPriceListThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(UpdateAllCampaignBidPriceThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(UpdateAllCampaignBidPriceThunk.fulfilled, (state, action) => {
        // if (action.payload.data?.results[0]) {
        //   state.demandPartnersList = action.payload.data?.results[0];
        // }
        state.loading = false;
      })
      .addCase(UpdateAllCampaignBidPriceThunk.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
        state.loading = false;
      })
      .addCase(getAllEligibleFutureTargetingCampaigns.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getAllEligibleFutureTargetingCampaigns.fulfilled,
        (state, action) => {
          if (action.payload.data?.results[0].length > 0) {
            state.retargetCampaignsList = action.payload.data?.results[0];
          }
          state.loading = false;
        }
      )
      .addCase(
        getAllEligibleFutureTargetingCampaigns.rejected,
        (state, action) => {
          //toast.error('Something went Wrong!');
          state.loading = false;
        }
      )
      .addCase(getHasCampaignTargetingBanners.pending, (state) => {})
      .addCase(getHasCampaignTargetingBanners.fulfilled, (state, action) => {})
      .addCase(getHasCampaignTargetingBanners.rejected, (state, action) => {
        //toast.error('Something went Wrong!');
      })
      .addCase(UpdateCampaignTargetingBannersThunk.pending, (state) => {
        state.bannerTargetingModalLoading = true;
      })
      .addCase(
        UpdateCampaignTargetingBannersThunk.fulfilled,
        (state, action) => {
          state.bannerTargetingModalLoading = false;
        }
      )
      .addCase(
        UpdateCampaignTargetingBannersThunk.rejected,
        (state, action) => {
          state.bannerTargetingModalLoading = false;
        }
      )
      .addCase(GetCampaignPackagesListThunk.pending, (state) => {})
      .addCase(GetCampaignPackagesListThunk.fulfilled, (state, action) => {
        if (action.payload.data?.results[0].length > 0) {
          state.campaignPackageList = action.payload.data?.results[0];
        }
      })
      .addCase(GetCampaignPackagesListThunk.rejected, (state, action) => {})
      .addCase(InsertCampaignPackageThunk.pending, (state) => {})
      .addCase(InsertCampaignPackageThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          let campPackages = cloneDeep(state.campaignPackageList);

          let id = action.payload.data?.results[0]?.id;
          let name = action.meta.arg.name;
          let accountid = action.meta.arg.accountid;
          campPackages.push({ value: id, label: name, accountid: accountid });
          state.campaignPackageList = campPackages;
        }
      })
      .addCase(InsertCampaignPackageThunk.rejected, (state, action) => {})
      .addCase(UpdateCampaignPackageThunk.pending, (state) => {})
      .addCase(UpdateCampaignPackageThunk.fulfilled, (state, action) => {
        if (action.payload.data?.error == false) {
          state.campaignPackageList = state.campaignPackageList.map((item) =>
            item.value == action.meta.arg.id
              ? { ...item, label: action.meta.arg.name }
              : item
          );
        }
      })
      .addCase(UpdateCampaignPackageThunk.rejected, (state, action) => {});
  },
});
const { actions, reducer } = Campaign;
export const {
  updateCampaignFiltersFormValues,
  updateCampaignFilters,
  updateCampaignFiltersDateValues,
  updateCampaignStatusList,
  updateBannerLoader,
} = actions;
// Extract and export each action creator by name
// export const {

// } = actions;
// Export the reducer, either as a default or named export
export default reducer;
